webpackJsonp([11],{

/***/ "+t+Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_common__ = __webpack_require__("CaOM");
/*正则验证相关

 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  validOrderNo: function validOrderNo(val) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__common_js_common__["f" /* getResouce */])() === 'upcard') {
      return { valid: true, msg: "" };
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__common_js_common__["f" /* getResouce */])() === 'o2o') {
      if (num.length === 17 || num.length === 15) {
        return { valid: true, msg: "" };
      } else {
        return { valid: false, msg: this.$t("订单号有误，请检查是否输入正确！") };
      }
    }
    if (this.orderNo(val)) {
      return { valid: true, msg: "" };
    } else {
      return { valid: false, msg: "订单号有误，请检查是否输入正确！" };
    }
  },
  validEmail: function validEmail(val) {
    if (this.email(val)) {
      return { valid: true, msg: "" };
    } else {
      return { valid: false, msg: "Email有误，请检查是否输入正确！" };
    }
  },

  // 校验税号
  validTaxNumber: function validTaxNumber(val) {
    if (val === null) {
      return { valid: true, msg: "" };
    }
    if (this.taxNumber(val)) {
      return { valid: true, msg: "" };
    } else {
      return { valid: false, msg: "税号有误" };
    }
  },
  validInvoiceTitle: function validInvoiceTitle(val) {
    // 校验抬头
    if (this.invoiceTitle(val)) {
      return { valid: true, msg: "" };
    } else {
      return { valid: false, msg: "抬头长度小于100" };
    }
  },

  /*订单号*/
  orderNo: function orderNo(num) {
    if (num == null) {
      return false;
    }
    if (num.length >= 16 && num.length <= 35) {
      return true;
    }
    return false;
  },

  /*手机号*/
  mobile: function mobile(num) {
    return (/^1[34578][0-9]{9}$/.test(num)
    );
  },

  /*座机号码*/
  phone: function phone(num) {
    return (/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,8}$/.test(num)
    );
  },

  /*邮箱*/
  email: function email(str) {
    if (str == null) {
      return false;
    }
    return (/^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(str)
    );
  },

  /*身份证*/
  idCard: function idCard(str) {
    return (/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(str)
    );
  },

  /*整数*/
  intNum: function intNum(num) {
    return (/(^[0-9]*$)/.test(num)
    );
  },

  /*整数或小数*/
  intOrFloatNum: function intOrFloatNum(str) {
    return (/^[0-9]+(\.[0-9]+)?$/.test(str)
    );
  },

  /*至少包含2种字符的6到16位密码*/
  password: function password(str) {
    return (/(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,16}$/.test(str)
    );
  },

  /*5位数字验证码*/
  code: function code(num) {
    return (/^\d{5}$/.test(num)
    );
  },


  /*发票代码    10或12位数字或大写字母*/
  invoiceCode: function invoiceCode(num) {
    return (/^[A-Z0-9]{10}$/.test(num) || /^[A-Z0-9]{12}$/.test(num)
    );
  },


  /*发票号码  8位数字*/
  invoiceNo: function invoiceNo(num) {
    return (/^\d{8}$/.test(num)
    );
  },


  /*发票代码或号码    需求5482，【发票代码、发票号码】可能是【数字、大小写英文】，且最多是25位*/
  invoiceCodeNo: function invoiceCodeNo(str) {
    var reg = /^[a-zA-Z0-9]+$/;
    if (str.length > 25 || !reg.test(str)) {
      return false;
    }
    return true;
  },


  /*是否是税号
  15-20位   英文数字 大写字母IOVZ除外
  */
  taxNumber: function taxNumber(str) {
    if (str == null) {
      return false;
    }
    //15-20位    中英文
    var reg = /^[0123456789ABCDEFGHJKLMNPQRTUWXY]+$/;
    var reg1 = /^\d{6}$/;
    if (str.length > 21 || str.length < 15 || !reg.test(str)) {
      return false;
    }
    /*
    if (str.indexOf("0") == 0) {
      return false;
    }
    var addressCode = str.substring(0, 6);
    if (!reg1.test(addressCode)) {
      return false;
    }*/
    return true;
  },

  /**验真发票抬头
   * 长度<100
   */
  invoiceTitle: function invoiceTitle(str) {
    return str != null && str.length < 100 && str.length > 0;
  },

  /*是否是GUID  格式如2064d355-c0b9-41d8-9ef7-9d8b26524751 */
  guid: function guid(str) {
    return (/^[A-Z0-9]{8}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{12}$/.test(str)
    );
  },

  /**是否是YYYYMMDD格式日期
   * 如果是则返回日期，如果不是返回空
   */
  toDateFromString: function toDateFromString(strDate) {
    if (strDate.length != 8) {
      return null;
    }
    var dtDate = null;
    var nYear = parseInt(strDate.substring(0, 4), 10);
    var nMonth = parseInt(strDate.substring(4, 6), 10);
    var nDay = parseInt(strDate.substring(6, 8), 10);
    if (isNaN(nYear) == true || isNaN(nMonth) == true || isNaN(nDay) == true) {
      return null;
    }
    dtDate = new Date(nYear, nMonth - 1, nDay);
    if (nYear != dtDate.getFullYear() || nMonth - 1 != dtDate.getMonth() || nDay != dtDate.getDate()) {
      return null;
    }
    return dtDate;
  }
});

/***/ }),

/***/ "2QZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invoiceTitleType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return invoiceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return routerNames; });
/**
 * 基础常量配置
 *
 */

/**
 * 抬头类型
 * 企业，个人或政府机构
 */
var invoiceTitleType = {
  /**企业 */
  company: 2,
  /**个人、政府机构 */
  person: 1,
  /**非企业性单位 */
  nonbusiness: 3
};

/**
 * 发票种类
 * 普通发票、电子普通发票、专用发票
 */
var invoiceType = {
  /**普通发票 */
  puTong: 1,
  /**电子普通发票 */
  dianZiPuTong: 2,
  /**专用发票 */
  zhuanYong: 3
};

/**路由名称 */
var routerNames = {
  //首页
  HomeIndex: 'HomeIndex',
  //登录页面
  login: 'login',
  //发票状态
  state: 'state',
  //发票抬头 首页、列表、模糊检索
  InvoiceTitleIndex: 'InvoiceTitleIndex',
  //发票抬头 新增
  InvoiceTitleCreate: 'InvoiceTitleCreate',
  //发票抬头 编辑
  InvoiceTitleUpdate: 'InvoiceTitleUpdate',
  //发票抬头 详情
  InvoiceTitleDetail: 'InvoiceTitleDetail',

  //发票分享到邮箱
  InvoiceShare2Email: 'InvoiceShare2Email',

  //订单开票 确认页面
  OrderInvoiceIssue: 'OrderInvoiceIssue',

  //发票列表页面
  OrderInvoices: 'OrderInvoices',
  //发票详情页
  OrderInvoicesOwtDetail: 'OrderInvoicesOwtDetail',
  //集成发票详情页
  OrderInvoicesImage: 'OrderInvoicesImage',

  //扫码开票
  Redirect: 'Redirect',
  Error404: '404'

};

/***/ }),

/***/ "2vzc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-05efdad7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("CRgB")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_2_vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7KPW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Krh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_tools_date_format_js__ = __webpack_require__("Hpey");
/**
* vue 全局过滤器
*
* @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
* @link
* @create 2018-03-15
*/



/* harmony default export */ __webpack_exports__["a"] = ({
  invoiceTypeFormat: function invoiceTypeFormat(val) {
    var rel = "";
    switch (val) {
      case 'ce':
        rel = '增值税电子普通发票';
        break;
      case 's':
        rel = '增值税专用发票';
        break;
      case 'ce':
        rel = '增值税电子普通发票';
        break;
      default:
        rel = '';
        break;
    }
    return rel;
  },

  /** 格式化金额
  * @param  value
  */
  amountFormat: function amountFormat(value) {
    var html, _val;
    value = Number(value).toFixed(2);
    if (value == 0) {
      value = 0;
      return html = "￥0.00";
    } else if (value.split('.')[1].substring(1) == 0) {
      value = Number(value).toFixed(2);
    }
    _val = value.split('.');
    return html = '￥' + value;
  },


  /** 格式化时间为指定格式
  * @param  time 时间字符串
  * @param  fmt  格式
  */
  formatDateTime: function formatDateTime(time, fmt) {
    if (time) {
      time = time.replace(/-/g, '/');
      return Object(__WEBPACK_IMPORTED_MODULE_0_vux_src_tools_date_format_js__["a" /* default */])(time, fmt);
    } else {
      return time;
    }
  },


  /** 格式化标题   控制字数
  * @param  value 文本
  * @param  leng  保留长度
  */
  formatTitle: function formatTitle(value, leng) {
    var rel = '';
    if (value && value.length > leng) {
      rel = value.substr(0, leng);
    } else {
      rel = value;
    }
    return rel;
  },


  /** 格式化  格式化时间  友好格式  如 刚刚 一分钟前
  * @param  time 时间 字符串
  * @param  fmt  要格式化的格式
  */

  friendlyTime: function friendlyTime(time, fmt) {
    var date = typeof time === 'number' ? new Date(time) : new Date((time || '').replace(/-/g, '/'));
    var diff = (new Date().getTime() - date.getTime()) / 1000;
    var dayDiff = Math.floor(diff / 86400);

    var isValidDate = Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());

    if (!isValidDate) {
      console.error('not a valid date');
    }
    var formatDate = function formatDate(date) {
      var today = new Date(date);
      var year = today.getFullYear();
      var month = ('0' + (today.getMonth() + 1)).slice(-2);
      var day = ('0' + today.getDate()).slice(-2);
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    };

    if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31) {

      return new Date(date).format(fmt);
    }

    return dayDiff === 0 && (diff < 60 && '刚刚' || diff < 120 && '1分钟前' || diff < 3600 && Math.floor(diff / 60) + '分钟前' || diff < 7200 && '1小时前' || diff < 86400 && Math.floor(diff / 3600) + '小时前') || dayDiff === 1 && '昨天' || dayDiff < 7 && dayDiff + '天前' || dayDiff < 31 && Math.ceil(dayDiff / 7) + '周前';
  },


  /**格式化 文档类型 简称
  * @param  docmentType 文档类型编号
  * @param  $t i10n国际化对象
  */
  formatDocumentShortName: function formatDocumentShortName(docmentType, $t) {
    var $self = this;
    if (!docmentType) return "";
    var rel = '<span class="document-mark warning">';
    switch (docmentType) {
      case '10001001':
        rel += '专';
        break;
      case '20001001':
      case '20001002':
        rel += '普';
        break;
      case '30001001':
        rel += '电';
        break;
      case '30001002':
        rel += '行';
        break;
      case '40001001':
        rel += '卷';
        break;

      case '50001001':
        rel += '机';
        break;

      case '50001009':
        rel += '飞';
        break;

      case '50001010':
        rel += '火';
        break;
      case '50001011':
        rel += '交';
        break;
      case '50001012':
        rel += '信';
        break;

      case '50001013':
        rel += '定';
        break;
      default:
        rel = '';
        break;
    }
    rel += '</span>';
    return rel;
  },


  /**格式化 发票类型 简称
  * @param  invoiceType 发票类型编号
  * @param  $t i10n国际化对象
  */
  formatInvoiceTypeShortName: function formatInvoiceTypeShortName(invoiceType, $t) {
    var $self = this;
    if (!invoiceType) return "";
    var rel = '<span class="document-mark normal">';
    switch (invoiceType) {
      case 's':
        rel += '专';
        break;
      case 'c':
        rel += '普';
        break;
      case 'ce':
        rel += '电';
        break;
      case 'ju':
        rel += '卷';
        break;

      case 'v':
        rel += '机';
        break;
      default:
        rel = '';
        break;
    }
    rel += '</span>';
    return rel;
  }
});

/***/ }),

/***/ "9ttw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CKVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/libs/clean-style.js
var clean_style = __webpack_require__("n9nh");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-bda6d4a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Id0d")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_2_vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CRgB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CaOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateMixed */
/* unused harmony export generateUuid */
/* harmony export (immutable) */ __webpack_exports__["j"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["g"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearToken;
/* harmony export (immutable) */ __webpack_exports__["i"] = setResouce;
/* harmony export (immutable) */ __webpack_exports__["f"] = getResouce;
/* unused harmony export setUserSetting */
/* unused harmony export getUserSetting */
/* unused harmony export clearUserSetting */
/* harmony export (immutable) */ __webpack_exports__["b"] = clog;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatDateTime2;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatDateTime3;
/* harmony export (immutable) */ __webpack_exports__["k"] = thousandBitSeparator;
/* unused harmony export copyObject */
/* harmony export (immutable) */ __webpack_exports__["e"] = getBrowserLanguage;
/* unused harmony export getVATQrcodeContent */
/* harmony export (immutable) */ __webpack_exports__["h"] = getUrlKey;
/* unused harmony export getCookie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("hRKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_base_js__ = __webpack_require__("Q4A5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__regexp_js__ = __webpack_require__("+t+Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_tools_date_format_js__ = __webpack_require__("Hpey");


/**
* 通用的帮助类
* vux中有很多的帮助类，也可以直接使用
* https://vux.li/#/zh-CN/README?id=%E5%B7%A5%E5%85%B7%E5%BA%93
*
* @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
* @link
* @create 2018-03-15
*/






var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
function generateMixed(n) {
  var res = '';
  for (var i = 0; i < n; i++) {
    var id = Math.ceil(Math.random() * 35);
    res += chars[id];
  }
  return res;
}

/**
* 生成UUID
*
* @returns
*/
function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

/**
* 设置token
* @param {any} token
*/
function setToken(token) {
  if (____isAppH5Browser()) {
    localStorage.setItem('invoiceAssistantMobileAuthInfoH5', token);
  }
  if (____isAlipayBrowser()) {
    localStorage.setItem('invoiceAssistantMobileAuthInfoAlipay', token);
  }
  if (____isWechatBrowser()) {
    localStorage.setItem('invoiceAssistantMobileAuthInfoWechat', token);
  }
}
/**
* 获取存储在 sessionStorage 中的token
* @returns
*/
function getToken() {

  var token = '';
  if (____isAppH5Browser()) {
    token = localStorage.getItem('invoiceAssistantMobileAuthInfoH5');
  }
  if (____isAlipayBrowser()) {
    token = localStorage.getItem('invoiceAssistantMobileAuthInfoAlipay');
  }
  if (____isWechatBrowser()) {
    token = localStorage.getItem('invoiceAssistantMobileAuthInfoWechat');
  }
  if (token === 'undefined' || token === 'null') {
    token = null;
  }
  return token;
}
/**
* 删除存储在 sessionStorage中的token
* @returns
*/
function clearToken() {
  if (____isAppH5Browser()) {
    localStorage.removeItem('invoiceAssistantMobileAuthInfoH5');
  }
  if (____isAlipayBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileAuthInfoAlipay');
  }
  if (____isWechatBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileAuthInfoWechat');
  }
}
/**
* 设置resouce
* @param {any} token
*/
function setResouce(resouce) {
  if (____isAppH5Browser()) {
    localStorage.setItem('invoiceAssistantMobileResouceH5', resouce);
  }
  if (____isAlipayBrowser()) {
    localStorage.setItem('invoiceAssistantMobileResouceAlipay', resouce);
  }
  if (____isWechatBrowser()) {
    localStorage.setItem('invoiceAssistantMobileResouceWechat', resouce);
  }
}
/**
* 获取resouce
* @param {any} token
*/
function getResouce() {
  var resouce = 'SUGUO-H5';
  if (____isAppH5Browser()) {
    resouce = localStorage.getItem('invoiceAssistantMobileResouceH5');
  }
  if (____isAlipayBrowser()) {
    resouce = localStorage.getItem('invoiceAssistantMobileResouceAlipay');
  }
  if (____isWechatBrowser()) {
    resouce = localStorage.getItem('invoiceAssistantMobileResouceWechat');
  }
  if (resouce === null || resouce === '' || resouce === 'undefined' || resouce === 'null') {
    resouce = "SUGUO-H5";
  }
  return resouce;
}
/**
* 设置用户自定义设置
* @param {any} token
*/
function setUserSetting(setting) {

  if (____isAppH5Browser()) {
    localStorage.setItem('invoiceAssistantMobileUserSettingH5', setting);
  }
  if (____isAlipayBrowser()) {
    localStorage.setItem('invoiceAssistantMobileUserSettingAlipay', setting);
  }
  if (____isWechatBrowser()) {
    localStorage.setItem('invoiceAssistantMobileUserSettingWechat', setting);
  }
}
/**
* 获取存储在 localStorage中的 用户自定义设置
* @returns
*/
function getUserSetting() {

  var setting = '';
  if (____isAppH5Browser()) {
    setting = localStorage.getItem('invoiceAssistantMobileUserSettingH5');
  }
  if (____isAlipayBrowser()) {
    setting = localStorage.getItem('invoiceAssistantMobileUserSettingAlipay');
  }
  if (____isWechatBrowser()) {
    setting = localStorage.getItem('invoiceAssistantMobileUserSettingWechat');
  }
  return setting;
}
/**
* 删除存储在 localStorage中的 用户自定义设置
* @returns
*/
function clearUserSetting() {

  if (____isAppH5Browser()) {
    localStorage.removeItem('invoiceAssistantMobileUserSettingH5');
  }
  if (____isAlipayBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileUserSettingAlipay');
  }
  if (____isWechatBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileUserSettingWechat');
  }
}

function clog($msg, $type) {
  var tm = Object(__WEBPACK_IMPORTED_MODULE_4_vux_src_tools_date_format_js__["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');

  var type = $type || 'info';
  var str = tm + ' [' + type + ']:' + ((typeof $msg === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()($msg)) === "object" ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()($msg) : $msg);
  if (__WEBPACK_IMPORTED_MODULE_2__config_base_js__["a" /* default */].debug) {
    if ($type === 'ERR') {
      console.log('%c' + str, 'color:#ff00ff;');
    } else {
      console.log('%c' + str, 'color:#0080ff;');
    }
  }
  return str;
}

/**
* 将格式如 20180402115522  时间字符串 格式化
* @param {*} dateStr   //YYYY-MM-DD HH:mm:ss
*/
function formatDateTime2(dateStr, fmt) {
  if (dateStr == null || dateStr.length === 0) {
    return '';
  }

  var tempDate = '' + dateStr[0] + dateStr[1] + dateStr[2] + dateStr[3] + '/' + dateStr[4] + dateStr[5] + '/' + dateStr[6] + dateStr[7] + ' ' + dateStr[8] + dateStr[9] + ':' + dateStr[10] + dateStr[11] + ':' + dateStr[12] + dateStr[13] + '';
  var tm = Object(__WEBPACK_IMPORTED_MODULE_4_vux_src_tools_date_format_js__["a" /* default */])(new Date(tempDate), fmt || 'YYYY-MM-DD HH:mm:ss');
  return tm;
}
/**
* 将格式如 20180402  日期字符串 格式化
* @param {*} dateStr
* @param {*} fmt   //YYYY-MM-DD HH:mm:ss
*/
function formatDateTime3(dateStr, fmt) {
  if (dateStr == null || dateStr.length === 0) {
    return '';
  }

  var tempDate = '' + dateStr[0] + dateStr[1] + dateStr[2] + dateStr[3] + '/' + dateStr[4] + dateStr[5] + '/' + dateStr[6] + dateStr[7] + ' ' + '00:00:00';
  var tm = Object(__WEBPACK_IMPORTED_MODULE_4_vux_src_tools_date_format_js__["a" /* default */])(new Date(tempDate), fmt || 'YYYY-MM-DD HH:mm:ss');
  return tm;
}
/**
* 将金额保留小数两位再转换为千分位
* @param {*} num
*/
function thousandBitSeparator(num) {
  if (isNaN(parseFloat(num))) {
    return "";
  }
  num = parseFloat(num).toFixed(2);
  return num && (num.toString().indexOf('.') !== -1 ? num.toString().replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
    return $1 + ",";
  }) : num.toString().replace(/(\d)(?=(\d{3}))/g, function ($0, $1) {
    return $1 + ",";
  }));
}

/*对象深拷贝
*create by yk 2016/5/19
*/

var util = function () {
  var class2type = {};
  ["Null", "Undefined", "Number", "Boolean", "String", "Object", "Function", "Array", "RegExp", "Date"].forEach(function (item) {
    class2type["[object " + item + "]"] = item.toLowerCase();
  });

  function isType(obj, type) {
    return getType(obj) === type;
  }

  function getType(obj) {
    return class2type[Object.prototype.toString.call(obj)] || "object";
  }
  return {
    isType: isType,
    getType: getType
  };
}();
/**
* 对象深copy  浅copy
*/
function copyObject(obj, deep) {

  if (obj === null || (typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== "object") {
    return obj;
  } //定义需要的局部变脸，根据obj的类型来调整target的类型
  var i,
      target = util.isType(obj, "array") ? [] : {},
      value,
      valueType;
  for (i in obj) {
    value = obj[i];
    valueType = util.getType(value);
    if (deep && (valueType === "array" || valueType === "object")) {
      target[i] = copyObject(value);
    } else {
      target[i] = value;
    }
  }
  return target;
}

/**
* 获取客户端浏览器语言环境
*/
function getBrowserLanguage() {
  return navigator.language || navigator.browserLanguage;
}

/**
* 解析发票二维码内容
*
* 增值税普通发票 01,04,3300164320,30856012,318.10,20180508,11475938679360667598,865b,
* 增值税专用发票 01,01,3100171130,09725707,3773.58,20170630,,EAB,
* 增值税电子普通发票 01,10,031001700311,50756616,1203.77,20180404,11475938679360667598,5EFF,
* 通行费增值税电子普通发票  01,10,011001700112,14280029,4.61,20180111,01916804770189053905,4F16,
* 增值税普通发票(卷票) 01,11,3100173320,30856012,,,,865b,
* 机动车销售统一发票  01,03,150001722060,00871843,118987.18,20180322,,CDA8,
*/
function getVATQrcodeContent(val) {

  var nowYear = new Date().getFullYear();

  if (val) {
    try {
      var arrVal = val.split(",");
      if (arrVal.length < 7) {
        return null;
      }

      if (arrVal[0] !== "01") {
        return null;
      }

      if (!(/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2]))) {
        return null;
      }

      if (/^\d{10}$/.test(arrVal[2])) {

        var one2four = parseInt(arrVal[2][0] + '' + arrVal[2][1] + arrVal[2][2] + arrVal[2][3]);

        if (one2four < 1100 || one2four > 1599 && one2four < 2100 || one2four > 2399 && one2four < 3100 || one2four > 3799 && one2four < 4100 || one2four > 4699 && one2four < 5000 || one2four > 5499 && one2four < 6100 || one2four > 6599) {
          return null;
        }

        var fivesix = parseInt('20' + arrVal[2][4] + '' + arrVal[2][5]);

        if (!(fivesix >= 2001 && fivesix <= nowYear)) {
          return null;
        }

        if ([1, 2, 3, 5, 6, 7, '1', '2', '3', '5', '6', '7'].indexOf(arrVal[2][7]) === -1) {
          return null;
        }
      }

      if (/^\d{12}$/.test(arrVal[2])) {
        /*
        第1位数字限制：0，1当第1位为0且第11-12位为11时为增值税电子普通发票；
        当第1位为0且第11-12位为04或05增值税普通发票（折叠票）（04-两联；05-五联）;
        当第1位为0且第11-12位为06或07时为增值税普通发票（卷票）；
        当第1位为1且第8位为2时为机动车销售统一发票.
        当第11-12为17二手车销售统一发票
        当第11-12为26通栏式发票
        当第1位为0且第11-12为12通行费电子普通发票
        */
        if ([0, 1, '0', '1'].indexOf(arrVal[2][0]) === -1) {
          return null;
        }

        var two2five = parseInt(arrVal[2][1] + '' + arrVal[2][2] + arrVal[2][3] + arrVal[2][4]);
        if (two2five < 1100 || two2five > 1599 && two2five < 2100 || two2five > 2399 && two2five < 3100 || two2five > 3799 && two2five < 4100 || two2five > 4699 && two2five < 5000 || two2five > 5499 && two2five < 6100 || two2five > 6599) {
          return null;
        }

        var sixsevern = parseInt('20' + arrVal[2][5] + '' + arrVal[2][6]);
        if (!(sixsevern >= 2001 && sixsevern <= nowYear)) {
          return null;
        }
      }

      if (!/^\d{8}$/.test(arrVal[3])) {
        return null;
      }

      if (arrVal[0] === "01" && arrVal[1] === "01" && /^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) && /^\d{8}$/.test(arrVal[5]) && __WEBPACK_IMPORTED_MODULE_3__regexp_js__["a" /* default */].toDateFromString(arrVal[5]) != null) {

        return {
          documentType: "10001001",
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: ""
        };
      }

      if (arrVal[0] === "01" && arrVal[1] === "11" && (/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) && /^\d{8}$/.test(arrVal[3]) && arrVal[4] === "" && arrVal[5] === "" && arrVal[6] === "" && arrVal[7] !== "") {
        return {
          documentType: "40001001",
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: arrVal[6]
        };
      }

      if (arrVal[0] === "01" && arrVal[1] === "03" && (/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) && /^\d{8}$/.test(arrVal[3]) && /^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) && /^\d{8}$/.test(arrVal[5]) && __WEBPACK_IMPORTED_MODULE_3__regexp_js__["a" /* default */].toDateFromString(arrVal[5]) != null) {
        return {
          documentType: "50001001",
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: arrVal[6]
        };
      }

      if (arrVal[0] === "01" && arrVal[1] === "10" && (/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) && /^\d{8}$/.test(arrVal[3]) && /^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) && /^\d{8}$/.test(arrVal[5]) && __WEBPACK_IMPORTED_MODULE_3__regexp_js__["a" /* default */].toDateFromString(arrVal[5]) != null && /^\d{20}$/.test(arrVal[6])) {
        return {
          documentType: "30001001",
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: arrVal[6]
        };
      }

      if (arrVal[0] === "01" && arrVal[1] === "04" && (/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) && /^\d{8}$/.test(arrVal[3]) && /^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) && /^\d{8}$/.test(arrVal[5]) && __WEBPACK_IMPORTED_MODULE_3__regexp_js__["a" /* default */].toDateFromString(arrVal[5]) != null && /^\d{20}$/.test(arrVal[6])) {
        return {
          documentType: "20001001",
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: arrVal[6]
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  } else {
    return null;
  }
}

/**
* 获取链接参数，参数可能分布在? #之间前后...
*/
function getUrlKey(url, name) {
  return decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(url) || [, ""])[1].replace(/\+/g, "%20")) || null;
}
/**
* 获取cookie
*/
function getCookie(c_name) {
  if (document.cookie.length > 0) {
    var c_start = "";
    var c_end = "";
    c_start = document.cookie.indexOf(c_name + "=");
    if (c_start !== -1) {
      c_start = c_start + c_name.length + 1;
      c_end = document.cookie.indexOf(";", c_start);
      if (c_end === -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

/***/ }),

/***/ "CbWb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D3X4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Id0d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iy0M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J/QH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-b4853fb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("T4qG")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var _vux_2_9_2_vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JGLT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("jHHs");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-07ea28c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _vux_2_9_2_vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("UmOo")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  _vux_2_9_2_vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules__vux_2_9_2_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("ZLEe");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_babel-polyfill@6.26.0@babel-polyfill/lib/index.js
var lib = __webpack_require__("briU");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/_vue@2.5.17@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("IvJb");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("4YfN");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/components/loading/index.vue + 3 modules
var loading = __webpack_require__("J/QH");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("Jp5S");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4bd8611d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/view-box/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tab"},[_vm._t("header"),_vm._v(" "),_c('div',{ref:"viewBoxBody",staticClass:"weui-tab__panel vux-fix-safari-overflow-scrolling",style:({paddingTop: _vm.bodyPaddingTop, paddingBottom: _vm.bodyPaddingBottom}),attrs:{"id":"vux_view_box_body"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_view_box = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/view-box/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("eJNS")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_view_box,
  src_components_view_box,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_2_vux_src_components_view_box = (Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/components/x-header/index.vue + 3 modules
var x_header = __webpack_require__("Z2Kc");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("DV+v");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-b03bcef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("D3X4")
}
var tabbar_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-53b5c389","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("r/Q/")
}
var badge_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_2_vux_src_components_badge = (badge_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: _vux_2_9_2_vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: _vux_2_9_2_vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-ab8ae38c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vuex@2.5.0@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("HVJf");

// EXTERNAL MODULE: ./src/common/js/common.js
var common = __webpack_require__("CaOM");

// EXTERNAL MODULE: ./node_modules/_axios@0.17.1@axios/index.js
var _axios_0_17_1_axios = __webpack_require__("2sCs");
var _axios_0_17_1_axios_default = /*#__PURE__*/__webpack_require__.n(_axios_0_17_1_axios);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue













/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      appClass: '',
      bodyPaddingTop: ____hasHeader ? '50px' : '0',
      bodyPaddingBottom: '0px',
      isFullBuleBg: this.$router.name === this.$routerNames.OrderInvoiceDetail || this.$router.name === this.$routerNames.InvoiceDetail
    };
  },

  components: {
    Loading: loading["a" /* default */],
    XHeader: x_header["a" /* default */],
    TransferDom: transfer_dom["a" /* default */],
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    ViewBox: _vux_2_9_2_vux_src_components_view_box
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  mounted: function mounted() {
    var $self = this;
    $self.appClass = ____hasHeader ? 'has-header' : '';
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    isLoading: function isLoading(state) {
      return state.common.isLoading;
    },
    direction: function direction(state) {
      return state.common.direction;
    }
  }), {
    viewTransition: function viewTransition() {
      var $self = this;
      if (!$self.direction) return '';
      return 'vux-pop-' + ('xxxx' === $self.direction ? 'xxxx' : $self.direction === 'forward' ? 'in' : 'out');
    }
  })
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue













/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  data: function data() {
    return {
      appClass: '',
      bodyPaddingTop: ____hasHeader ? '50px' : '0',
      bodyPaddingBottom: '0px',
      isFullBuleBg: this.$router.name === this.$routerNames.OrderInvoiceDetail || this.$router.name === this.$routerNames.InvoiceDetail
    };
  },

  components: {
    Loading: loading["a" /* default */],
    XHeader: x_header["a" /* default */],
    TransferDom: transfer_dom["a" /* default */],
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    ViewBox: _vux_2_9_2_vux_src_components_view_box
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  mounted: function mounted() {
    var $self = this;
    $self.appClass = ____hasHeader ? 'has-header' : '';
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    isLoading: function isLoading(state) {
      return state.common.isLoading;
    },
    direction: function direction(state) {
      return state.common.direction;
    }
  }), {
    viewTransition: function viewTransition() {
      var $self = this;
      if (!$self.direction) return '';
      return 'vux-pop-' + ('xxxx' === $self.direction ? 'xxxx' : $self.direction === 'forward' ? 'in' : 'out');
    }
  })
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-d21de0da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appClass,attrs:{"id":"app"}},[_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('loading',{model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}})],1),_vm._v(" "),_c('view-box',{ref:"viewBox",attrs:{"body-padding-top":_vm.bodyPaddingTop,"body-padding-bottom":_vm.bodyPaddingBottom}},[_c('div',[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)])],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("tQvA")
}
var App_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vue-router@3.0.2@vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("KGCO");

// EXTERNAL MODULE: ./src/store/actions.js
var actions = __webpack_require__("mUbh");
var actions_default = /*#__PURE__*/__webpack_require__.n(actions);

// EXTERNAL MODULE: ./src/store/getters.js
var getters = __webpack_require__("UjVw");
var getters_default = /*#__PURE__*/__webpack_require__.n(getters);

// EXTERNAL MODULE: ./src/store/mutations.js
var mutations = __webpack_require__("ukYY");
var mutations_default = /*#__PURE__*/__webpack_require__.n(mutations);

// EXTERNAL MODULE: ./src/store/state.js
var store_state = __webpack_require__("lwq5");
var state_default = /*#__PURE__*/__webpack_require__.n(store_state);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("a3Yh");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutation-types.js
/**
 * 定义 mutation 里用到的方法常量值，统一处理在这里，一般都是业务字符串常量
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

//测试用
var DEMO_TEST = 'DEMO_TEST';

var ADD_TO_CART = 'ADD_TO_CART';
var TOGGLE_STATUS = 'TOGGLE_STATUS';
var DELETE_PRODUCT = 'DELETE_PRODUCT';
var ADD_PRODUCT = 'ADD_PRODUCT';
var CUT_PRODUCT = 'CUT_PRODUCT';
var TOGGLE_ALLCHEK = 'TOGGLE_ALLCHEK';
var UPDATE_ADDRESS = 'UPDATE_ADDRESS';
var PLACE_ORDER = 'PLACE_ORDER';

//更新用户信息
var UPDATE_USERINFO = 'UPDATE_USERINFO';

//更新banner标题
var UPDATE_TITLE = 'UPDATE_TITLE';
//页面加载表示
var UPDATE_LOADING = 'UPDATE_LOADING';
//页面切换方向
var UPDATE_DIRECTION = 'UPDATE_DIRECTION';

//发票抬头
//新增
var ADD_INVOICE_TITLE = 'ADD_INVOICE_TITLE';
//删除
var DELETE_INVOICE_TITLE = 'DELETE_INVOICE_TITLE';
//修改
var UPDATE_INVOICE_TITLE = 'UPDATE_INVOICE_TITLE';
//列表
var LIST_INVOICE_TITLE = 'LIST_INVOICE_TITLE';

//发票
//新增
var ADD_INVOICE = 'ADD_INVOICE';
//删除
var DELETE_INVOICE = 'DELETE_INVOICE';
//修改
var UPDATE_INVOICE = 'UPDATE_INVOICE';
//分页列表
var PAGELIST_INVOICE = 'PAGELIST_INVOICE';

//更新发票影像的标签列表
var UPDATE_INVOICE_TAGS = 'UPDATE_INVOICE_TAGS';

//设置发票影像详情
var SET_INVOICE_INFO = 'SET_INVOICE_INFO';

//设置发票影像列表是否刷新  刷新机制有2种     1、更新某一条；2刷新整个列表
var SET_INVOICE_INDEX_RELOAD = 'SET_INVOICE_INDEX_RELOAD';

// export const
// CONCATENATED MODULE: ./src/store/modules/common.js


var _mutations;

/**
 * 通用模块 store状态管理
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */



var common_state = {
  userInfo: localStorage['userInfo'] ? JSON.parse(localStorage['userInfo']) : null,
  // cartData: localStorage['cartData']
  //     ? JSON.parse(localStorage['cartData'])
  //     : [],
  demoT: '我是测试数据',
  title: '华润万家超市',
  isLoading: false,
  direction: 'xxxx' //forward  reverse
};

// 唯一改变状态的地方
var common_mutations = (_mutations = {}, defineProperty_default()(_mutations, DEMO_TEST, function (state, tv) {
  state.demoT = tv;
}), defineProperty_default()(_mutations, UPDATE_USERINFO, function (state, _ref) {
  var userInfo = _ref.userInfo;

  state.userInfo = userInfo;
}), defineProperty_default()(_mutations, UPDATE_LOADING, function (state, status) {
  state.isLoading = status;
}), defineProperty_default()(_mutations, UPDATE_DIRECTION, function (state, direction) {
  state.direction = direction;
}), defineProperty_default()(_mutations, UPDATE_TITLE, function (state, title) {
  state.title = title;
}), _mutations);

// 包含异步操作(例如从后端拿到数据),
//改变状态必须commit   mutations去改变状态
//全局的  命名规范   模块名_ac_名称
var common_actions = {
  common_ac_setDemoT: function common_ac_setDemoT(_ref2, tv) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;

    commit(DEMO_TEST, tv);
  },

  /**设置页面是后退的状态 */
  common_ac_setPageDirectionForward: function common_ac_setPageDirectionForward(_ref3) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState;

    commit(UPDATE_DIRECTION, 'forward');
  },

  /**设置页面是前进的状态 */
  common_ac_setPageDirectionReverse: function common_ac_setPageDirectionReverse(_ref4) {
    var commit = _ref4.commit,
        rootState = _ref4.rootState;

    commit(UPDATE_DIRECTION, 'reverse');
  },

  /**设置页面是加载的状态 */
  common_ac_setPageLoadingTrue: function common_ac_setPageLoadingTrue(_ref5) {
    var commit = _ref5.commit,
        rootState = _ref5.rootState;

    commit(UPDATE_LOADING, true);
  },

  /**设置页面是加载完毕的状态 */
  common_ac_setPageLoadingFalse: function common_ac_setPageLoadingFalse(_ref6) {
    var commit = _ref6.commit,
        rootState = _ref6.rootState;

    commit(UPDATE_LOADING, false);
  },

  /**设置页面标题 */
  common_ac_setPageTitle: function common_ac_setPageTitle(_ref7, title) {
    var commit = _ref7.commit,
        rootState = _ref7.rootState;

    commit(UPDATE_TITLE, title);
  }
};

// store里面的计算属性  全局的  命名规范   模块名_gt_名称
//模块名 加名称
var common_getters = {
  common_gt_demoTest: function common_gt_demoTest(state, getters, rootState, rootGetters) {
    return state.demoT;
  },

  /**获取页面加载状态 */
  common_gt_pageLoading: function common_gt_pageLoading(state, getters, rootState, rootGetters) {
    return state.isLoading;
  },

  /** 获取页面加载方向
   */
  common_gt_pageDirection: function common_gt_pageDirection(state, getters, rootState, rootGetters) {
    return state.direction;
  },
  common_gt_userInfo: function common_gt_userInfo(state, getters, rootState, rootGetters) {
    return state.userInfo;
  }
};

/**
 * actions, mutations, getters, 限定在当前模块的命名空间中。
 * 只要给我们的模块加一个namespaced 属性
 * 当所有的actions, mutations, getters
 * 都被限定到模块的命名空间下，我们dispatch actions,
 * commit mutations 都需要用到命名空间。
 * 如 dispacth("changeName"), 就要变成 dispatch("login/changeName");
 *  getters.localJobTitle 就要变成 getters["login/localJobTitle"]
 */
/* harmony default export */ var modules_common = ({
  // namespaced:true,  //这里不限定
  state: common_state,
  mutations: common_mutations,
  actions: common_actions,
  getters: common_getters

  // export default {
  //     state:{},
  //     mutatons:{},
  //     actions:{},
  //     getters:{}
  // }

});
// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("3cXf");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/store/modules/invoice.js



var invoice__mutations;

/**
 * 发票影像模块 store状态管理
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */



var invoice_state = {
  invoiceInfo: {
    labels: []
  },
  //发票列表是否需要刷新
  invoiceIndexReload: {
    type: null, //  1  刷新某一条  一般是编辑后返回    ；2  刷新整个列表  一般用于添加新票据后 刷新
    reserve: '' //保留   当type = 1时候，存储的是票据id
  }
};

// 唯一改变状态的地方
var invoice_mutations = (invoice__mutations = {}, defineProperty_default()(invoice__mutations, SET_INVOICE_INFO, function (state, newVal) {
  state.invoiceInfo = JSON.parse(stringify_default()(newVal));
}), defineProperty_default()(invoice__mutations, UPDATE_INVOICE_TAGS, function (state, newVal) {
  state.invoiceInfo.labels = JSON.parse(stringify_default()(newVal));
}), defineProperty_default()(invoice__mutations, SET_INVOICE_INDEX_RELOAD, function (state, newVal) {
  state.invoiceIndexReload = JSON.parse(stringify_default()(newVal));
}), invoice__mutations);

// 包含异步操作(例如从后端拿到数据),
//改变状态必须commit   mutations去改变状态
//全局的  命名规范   模块名_ac_名称
var invoice_actions = {

  /**设置发票标签 */
  invoice_ac_setInvoiceTags: function invoice_ac_setInvoiceTags(_ref, newVal) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    commit(UPDATE_INVOICE_TAGS, newVal);
  },

  /**设置发票信息 */
  invoice_ac_setInvoiceInfo: function invoice_ac_setInvoiceInfo(_ref2, newVal) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;

    commit(SET_INVOICE_INFO, newVal);
  },

  /**设置发票列表是否需要刷新 */
  invoice_ac_setinvoiceIndexReload: function invoice_ac_setinvoiceIndexReload(_ref3, newVal) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState;

    commit(SET_INVOICE_INDEX_RELOAD, newVal);
  }
};

// store里面的计算属性  全局的  命名规范   模块名_gt_名称
//模块名 加名称
var invoice_getters = {
  invoice_gt_invoiceTags: function invoice_gt_invoiceTags(state, getters, rootState, rootGetters) {
    return state.invoiceInfo.labels;
  },
  invoice_gt_invoiceInfo: function invoice_gt_invoiceInfo(state, getters, rootState, rootGetters) {
    return state.invoiceInfo;
  },
  invoice_gt_invoiceIndexReload: function invoice_gt_invoiceIndexReload(state, getters, rootState, rootGetters) {
    return state.invoiceIndexReload;
  }
};

/**
 * actions, mutations, getters, 限定在当前模块的命名空间中。
 * 只要给我们的模块加一个namespaced 属性
 * 当所有的actions, mutations, getters
 * 都被限定到模块的命名空间下，我们dispatch actions,
 * commit mutations 都需要用到命名空间。
 * 如 dispacth("changeName"), 就要变成 dispatch("login/changeName");
 *  getters.localJobTitle 就要变成 getters["login/localJobTitle"]
 */
/* harmony default export */ var invoice = ({
  // namespaced:true,  //这里不限定
  state: invoice_state,
  mutations: invoice_mutations,
  actions: invoice_actions,
  getters: invoice_getters

  // export default {
  //     state:{},
  //     mutatons:{},
  //     actions:{},
  //     getters:{}
  // }

});
// EXTERNAL MODULE: ./node_modules/_vuex-i18n@1.10.5@vuex-i18n/dist/vuex-i18n.es.js
var vuex_i18n_es = __webpack_require__("cdCE");

// EXTERNAL MODULE: ./node_modules/_vuex@2.5.0@vuex/dist/logger.js
var logger = __webpack_require__("acCT");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// CONCATENATED MODULE: ./src/common/i18n/en.js


var _translations;

/**
 * 英文语言包
 * 
 * 
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link 
 * @create 2018-03-15 
 */

var translations = (_translations = {
  //操作
  '提交': 'Submit',
  '下一步': 'Next',
  '返回': 'Back',
  '关闭': 'Close',
  '保存': 'Save',
  '保存并验真': 'Save & Check',
  '确定': 'Ok',
  '上传': 'Upload',
  '取消': 'Cancel',
  '编辑': 'Edit',
  '编辑及验真': 'Edit & Check',
  '报销': 'Reimburse',
  '打印': 'Print',
  '删除': 'Remove',

  '登录': 'Login',
  '获取验证码': 'Get code',
  '获取': 'Get',
  '绑定': 'Bind',
  '选择发票抬头': 'Choose Receipt Title',
  '使用微信抬头': 'Use WeChat Title',

  '查看发票': 'Check the Receipt',
  '查看票据': 'Check the Receipt',
  '下载发票': 'Download Receipt',
  '发到邮箱': 'Send to Email',
  '复制发票链接': 'Copy Receipt Link',
  '放入卡包': 'Put in the package',
  '添加抬头': 'New',
  '添加标签': 'New',
  '更多信息': 'Show More',
  // '新增抬头': 'Create',
  '更多操作': 'More',

  '推荐给朋友': 'Recommend to Friends',
  '设置标签': 'Set tags',
  '清理缓存': 'Clear local storage',

  //提示
  '标签管理小提示': 'Tip: the left slide list can be edited.',
  '提示': 'Warning',
  '删除警告': 'Cannot recover after deletion, confirm to continue?',
  '长按下面文字复制': 'Long press to copy',
  '加载完毕': 'Loaded',
  '加载中': 'Loading',
  '加载失败': 'Load failure',
  '没有任何记录': 'No record',
  '本服务由票易通提供': 'The service is provided by xforceplus, and the hotline :400-630-4000',
  '必填': 'Required',
  '选填': 'Optional',
  '操作成功': 'Success',
  '删除成功': 'Success',
  '修改成功': 'Success',

  '长按识别二维码关注公众号并开票': 'Long press the qrcode to follow wechat public account and receipt',
  '开票成功提示': 'Dear user, your application has been submitted successfully. Please pay attention to the result of the receipt.',
  '抬头上传成功提示': 'Upload successfully, Please wait to invoice',
  '开票注意事项': 'Note:according to article 2 of the state administration of taxation no. 16 of 2017, the contents of the receipt should be issued according to the actual sales situation (only the details are issued).',
  '税号有误': 'Tax ID is wrong',
  '发票抬头长度小于100': 'The receipt title length is less than 100',
  '抬头信息': 'Title infos',
  '订单信息': 'Order infos',
  '请准确填写抬头信息': 'Please fill in the receipt title accurately',
  '请准确填写收件人信息': 'Please fill in the contact info accurately',
  '获取订单信息失败': 'Fail to get order info',
  '表单验证失败提示': 'Error or formatting error in information',

  '发票验真结果法律说明': 'The inspection result of the receipt is not the legal basis, please refer to the local tax authorities.',
  '该发票已通过国税局验真': 'This receipt has been verified by the irs.',

  '该发票未验真': 'This receipt is not verified',
  '该发票验真中': 'The receipt is being checked, please check the result later.',
  '编辑增值税发票友情提示': 'Note:the VAT receipt、Unified sales invoice for motor vehicles only needs to edit the above items, and the other information will be updated automatically after the verification success.',
  '编辑增值税发票保存成功': 'The information is saved successfully, and other relevant information will be updated automatically later, which may take a few minutes.',
  '票据信息保存成功': 'The information is saved successfully',

  // '编辑发票友情提示': '',

  '保存成功': 'Save Success',
  '保存失败': 'Save Failed',
  '提交成功': 'Submitted Successfully',

  '请输入手机号码': 'Please enter your mobile',
  '请输入邮箱': 'Please enter your email',
  '请输入收票邮箱': 'Please enter your email',
  '请输入抬头(必填)': 'Please enter your receipt title(required)',
  '请输入手机号码(必填)': 'Please enter your mobile(required)',
  '请输入收票邮箱(必填)': 'Please enter your email(required)',

  '请选择发票抬头': 'Please select the receipt title',
  '请选择抬头': 'Please select the receipt title',
  '请输入抬头': 'Please enter your receipt title',

  '请输入购销方名称': 'Search..',
  '请输入验证码': 'Please enter the verification code',

  '请输入标签名': 'Please enter the tag name',
  '标签名已存在': 'The tag already exist',
  '标签名称过长': 'The tag length is less than 8',

  '10或12位': '10 or 12 digits or upper case letters',
  '8位': '8 digits',
  '不含税': 'No tax',
  '输入后6位': 'Enter the last 6 digits',

  '请选择票据分类': 'Please select the type',
  '请输入车次': 'Please enter the train No.',
  '请输入航班': 'Please enter the flight No.',
  '请选择始发地': 'Please select the address',
  '请选择到达地': 'Please select the address',
  '请选择出行日期': 'Please select the date',
  '票据说明': 'Note',
  '绑定手机邮箱提示': 'To ensure the security of your electronic receipt, please bind the mobile phone and mail box.',

  '请选择发票日期': 'Please select receipt date',
  '票据影像不存在': 'The receipt image does not exist',
  '已经被处理的票据不允许删除': 'Receipt that have been processed are not allowed to be deleted.',
  '验真成功或验真中的票据不允许编辑': 'It is not allowed to be edited for a true or true check.',

  '手机号绑定成功': 'Mobile phone number binding successfully.',
  '手机号解除绑定成功': 'The phone number is unbound successfully.',
  '验证码已发送,请注意查收': 'The verification code has been sent. Please check.',

  '手机号码未绑定': 'Mobile phone number unbound.',
  '收票邮箱未设置': 'Email unbound',
  '请设置': 'Please set up',
  '未设置': 'Not Set',
  '解除绑定警告': 'After untying, your receipt security will not be guaranteed, determined to continue?',
  '文件提交成功': 'File submission success',
  '增值税发票上传成功': 'The receipt has been put in my wallet, waiting for identification and verification.',
  '微信发票导入成功': 'WeChat receipt imported successfully',
  '下拉刷新': 'Tip:drop-down can refresh the list',
  '增值税发票拍照说明': 'Special VAT receipts, ordinary VAT receipts, VAT electronic receipts,  VAT electronic receipts(tolls), ordinary VAT receipts (volume tickets), etc;',
  '其他票据拍照说明': 'Train tickets, taxi tickets, airline tickets, communication fee receipts, bank receipt vouchers, quota receipts, overseas receipts, etc.',
  '扫发票二维码': 'Scan Qrcode',
  '扫发票二维码说明': 'Scan Qrcode do not support electronic；',
  '正在进行图片预处理': 'Image preprocessing is under way',
  '正在上传文件': 'Uploading files',
  '发票影像列表是空的，无法上传': 'The invoice image list is empty and cannot be uploaded',
  '共上传': '',
  '个发票影像': ' files uploaded',
  '无': 'no data',
  '请输入名称': 'Please enter the name',
  '该终端不支持扫一扫功能': 'Not support',
  '已被他人保存': 'It has been saved by others.',

  //页面名称  栏目标题
  '票税助手': 'xforceplus',
  '订单发票': 'Order Receipt',
  '发票影像': 'Receipt List',
  '拍发票': 'Photo Receipt',
  '票据详情': 'Receipt Detail',
  '标签管理': 'Tags',

  '导入微信发票': 'Import Receipt',
  '共': '',
  '张票据，累计金额': ' bills, ',
  '即将开通，敬请期待': 'To be open, please look forward to it',
  '选取发票失败': 'Choose receipt Failed',
  '取消选取发票': 'Cancellation of Receipt',

  '抬头管理': 'Receipt Title',
  '开户行': 'Bank',
  '发票号码': 'Receipt No.',
  '发票代码': 'Receipt Code',
  '您要添加哪种票据': 'What kind of receipt do you want to add?',
  '拍照技巧': 'Photo Skills',
  '上传发票PDF': 'Upload PDF',
  '上传发票': 'Upload Receipt',
  '确定上传发票': 'Determine the Upload'
}, defineProperty_default()(_translations, '\u626B\u53D1\u7968\u4E8C\u7EF4\u7801', 'Scan Receipt'), defineProperty_default()(_translations, '帮助中心', 'Help Center'), defineProperty_default()(_translations, '个人中心', 'My'), defineProperty_default()(_translations, '关于我们', 'About Us'), defineProperty_default()(_translations, '绑定手机', 'Bind Mobile'), defineProperty_default()(_translations, '绑定邮箱', 'Bind Email'), defineProperty_default()(_translations, '设置收票邮箱', 'Set Mailbox'), defineProperty_default()(_translations, '重新绑定手机', 'Rebind Mobile'), defineProperty_default()(_translations, '解除绑定', 'Unlink'), defineProperty_default()(_translations, '登录票税助手', 'Login xForceplus'), defineProperty_default()(_translations, '验证码', 'Valid Code'), defineProperty_default()(_translations, "订单号", "Order No."), defineProperty_default()(_translations, '订单金额', 'Order Amount'), defineProperty_default()(_translations, '订单日期', 'Order Date'), defineProperty_default()(_translations, '发票金额', 'Receipt Amount'), defineProperty_default()(_translations, '发票日期', 'Receipt Date'), defineProperty_default()(_translations, '发票详情', 'Receipt Details'), defineProperty_default()(_translations, '编辑发票', 'Edit Receipt'), defineProperty_default()(_translations, '不含税金额', 'Total Amount'), defineProperty_default()(_translations, '税额', 'Total Tax'), defineProperty_default()(_translations, '含税金额', 'Amount with Tax'), defineProperty_default()(_translations, '新增抬头', 'New Receipt Title'), defineProperty_default()(_translations, '新增标签', 'New Tag'), defineProperty_default()(_translations, '新增票据', 'New Receipt'), defineProperty_default()(_translations, '编辑票据', 'Edit Receipt'), defineProperty_default()(_translations, '新增发票', 'New Receipt'), defineProperty_default()(_translations, '上传抬头', 'Upload Receipt'), defineProperty_default()(_translations, '增值税发票', 'VAT'), defineProperty_default()(_translations, '其他票据', 'Other Receipt'), defineProperty_default()(_translations, '抬头类型', 'Type'), defineProperty_default()(_translations, '企业', 'Enterprise'), defineProperty_default()(_translations, '个人或政府机构', 'Personal'), defineProperty_default()(_translations, '发票类型', 'Invoice Type'), defineProperty_default()(_translations, '电子发票', 'Electronic'), defineProperty_default()(_translations, '纸质发票', 'Paper'), defineProperty_default()(_translations, '抬头', 'Title'), defineProperty_default()(_translations, '发票抬头', 'Receipt Title'), defineProperty_default()(_translations, '税号', 'Tax ID'), defineProperty_default()(_translations, '手机号码', 'Mobile'), defineProperty_default()(_translations, '手机号', 'Mobile'), defineProperty_default()(_translations, '邮箱', 'Email'), defineProperty_default()(_translations, '收票邮箱', 'Mailbox'), defineProperty_default()(_translations, '地址', 'Address'), defineProperty_default()(_translations, '电话', 'Tel'), defineProperty_default()(_translations, '电话号码', 'Tel'), defineProperty_default()(_translations, '企业地址', 'Address'), defineProperty_default()(_translations, '开户银行', 'Bank'), defineProperty_default()(_translations, '银行账号', 'Account No.'), defineProperty_default()(_translations, '费用', 'Cost'), defineProperty_default()(_translations, '元', 'Yuan'), defineProperty_default()(_translations, '开具发票', 'Receipt'), defineProperty_default()(_translations, '二维码开票', 'Receipt by Qrcode'), defineProperty_default()(_translations, '关注公众号', 'Follow Wechat Public Account'), defineProperty_default()(_translations, '增值税电子普通发票', 'VAT electronic ordinary receipt'), defineProperty_default()(_translations, '销售方', 'Seller'), defineProperty_default()(_translations, '购买方', 'Buyer'), defineProperty_default()(_translations, '编辑抬头', 'Modify Receipt Title'), defineProperty_default()(_translations, '抬头详情', 'Receipt Title'), defineProperty_default()(_translations, '默认抬头', 'Default'), defineProperty_default()(_translations, '默认', 'Default'), defineProperty_default()(_translations, '设为默认', 'Set as Default'), defineProperty_default()(_translations, '报销发票', 'Receipt for Reimbursement'), defineProperty_default()(_translations, '已开发票', 'Receipt'), defineProperty_default()(_translations, '我的票夹', 'Receipt'), defineProperty_default()(_translations, '票夹', 'Receipt Package'), defineProperty_default()(_translations, '发票验真', 'Verify Receipt'), defineProperty_default()(_translations, '发票归集', 'New'), defineProperty_default()(_translations, '分类', 'Type'), defineProperty_default()(_translations, '类型', 'Type'), defineProperty_default()(_translations, '状态', 'Status'), defineProperty_default()(_translations, '日期', 'Date'), defineProperty_default()(_translations, '归集日期', 'Collection Date'), defineProperty_default()(_translations, '校验码', 'Check Code'), defineProperty_default()(_translations, '查看验真结果', 'Verify results'), defineProperty_default()(_translations, '标签', 'Tags'), defineProperty_default()(_translations, '管理标签', 'Manage Tags'), defineProperty_default()(_translations, '商品明细', 'Receipt Details'), defineProperty_default()(_translations, '名称', 'Name'), defineProperty_default()(_translations, '金额', 'Amount'), defineProperty_default()(_translations, '税率', 'Tax Rate'), defineProperty_default()(_translations, '金额/税率', 'Amount/Tax rate'), defineProperty_default()(_translations, '备注', 'Note'), defineProperty_default()(_translations, '发票备注', 'Invoice Note'), defineProperty_default()(_translations, '个人备注', 'Personal Note'), defineProperty_default()(_translations, '始发地', 'From City'), defineProperty_default()(_translations, '到达地', 'To City'), defineProperty_default()(_translations, '从', 'From'), defineProperty_default()(_translations, '到', 'To'), defineProperty_default()(_translations, '上车时间', 'Start Time'), defineProperty_default()(_translations, '下车时间', 'End Time'), defineProperty_default()(_translations, '出行日期', 'Travel Date'), defineProperty_default()(_translations, '车次', 'Train No.'), defineProperty_default()(_translations, '航班', 'Flight No.'), defineProperty_default()(_translations, '票据信息', 'Infomation'), defineProperty_default()(_translations, '服务电话', 'Tel'), defineProperty_default()(_translations, '服务邮箱', 'Email'), defineProperty_default()(_translations, '上拉加载更多', 'Pull up load more'), defineProperty_default()(_translations, '\u4E0B\u62C9\u5237\u65B0', 'Pull down to refresh'), defineProperty_default()(_translations, '松开加载', 'Release to load'), defineProperty_default()(_translations, '松开刷新', 'Release to refresh'), defineProperty_default()(_translations, '已报销', 'Reimbursed'), defineProperty_default()(_translations, '未报销', 'Unreimbursed'), defineProperty_default()(_translations, '待识别', 'Undiscern'), defineProperty_default()(_translations, '识别中', 'Discerning'), defineProperty_default()(_translations, '识别完成', 'Discerned'), defineProperty_default()(_translations, '识别失败', 'Discern Failed'), defineProperty_default()(_translations, '验真成功', 'Verified'), defineProperty_default()(_translations, '验真失败', 'Verify Failed'), defineProperty_default()(_translations, '待验真', 'Unverified'), defineProperty_default()(_translations, '验真中', 'Verifing'), defineProperty_default()(_translations, '发票邮寄地址', 'Express Address'), defineProperty_default()(_translations, '收件人', 'Contact'), defineProperty_default()(_translations, '联系电话', 'Contact Tel'), defineProperty_default()(_translations, '所在地区', 'District'), defineProperty_default()(_translations, '详细地址', 'Detail Address'), defineProperty_default()(_translations, '电话有误', 'Invalid Tel'), defineProperty_default()(_translations, '请使用微信或支付宝开票', 'Please invoice in Wechat or Alipay'), defineProperty_default()(_translations, '订单异常，无法开票，请联系开票员', 'Fail to invoice, please contact the staff'), defineProperty_default()(_translations, '门店号', 'Storecode'), defineProperty_default()(_translations, '纸质专票', 'Special Invoice'), defineProperty_default()(_translations, '小票已申请开票，请勿重复申请', 'You already apply the invoice'), defineProperty_default()(_translations, '房间号', 'Room Id'), defineProperty_default()(_translations, '姓名', 'UserName'), defineProperty_default()(_translations, '更新日期', 'Update Date'), defineProperty_default()(_translations, '工作流号', 'Work flow'), defineProperty_default()(_translations, '报销金额', 'Reimbursement amount'), defineProperty_default()(_translations, '发票开具成功', 'Invoice Done'), defineProperty_default()(_translations, '该发票已被他人领取', 'The invoice has been received by others'), defineProperty_default()(_translations, '发票开具中', 'Invoice opening'), defineProperty_default()(_translations, '发票申请成功提示', 'The e-invoice will be completed within 24 hours. You will receive the notification after the successful opening.'), defineProperty_default()(_translations, '已被他人开具提示', 'The order has been issued by other people, and can not be repeated.'), defineProperty_default()(_translations, '开票申请提交成功', 'Apply the invoice successfully.'), defineProperty_default()(_translations, '查看开票状态', 'Check the invoice progress'), defineProperty_default()(_translations, '所属集团', 'Group'), defineProperty_default()(_translations, '集团信息', 'Group Info'), defineProperty_default()(_translations, '集团名称', 'Group Name'), defineProperty_default()(_translations, '请输入您所在集团的全称', 'Please input your group name'), defineProperty_default()(_translations, '个人工号', 'Personal NO'), defineProperty_default()(_translations, '请输入您的个人工号', 'Please input your Personal NO'), defineProperty_default()(_translations, '以上信息仅作为公司系统接入时发票抽取凭证', 'The above information is only used as invoice extraction certificate when the company system is connected.'), defineProperty_default()(_translations, '本功能仅限合作商户使用', 'This function is limited to the use of the cooperative merchants'), defineProperty_default()(_translations, '集团绑定成功', 'Bind group successfully'), defineProperty_default()(_translations, '集团名称不能超过200位', 'The length of company name is too long'), defineProperty_default()(_translations, '个人工号不能超过20位', 'The length of personal No is too long'), defineProperty_default()(_translations, '扫码添加的发票无图像，如需保存图像，请选择其他方式', 'There is no image for the invoice added to scan code. If you want to save the image, please choose other ways.'), defineProperty_default()(_translations, '已占用', 'Invoice used'), defineProperty_default()(_translations, '填写2项数据，可完成绑定；清空2项数据，可完成解绑', 'Fill in both of them to bind company or clear both of them to unbind'), defineProperty_default()(_translations, '报销中', 'Reimbursing'), defineProperty_default()(_translations, '已完成', 'finish'), defineProperty_default()(_translations, '开票中', 'invoicing'), defineProperty_default()(_translations, '月份', 'Month'), defineProperty_default()(_translations, '开票状态', 'Invoice status'), defineProperty_default()(_translations, '请填写正确的邮箱', 'Please input your correct email'), defineProperty_default()(_translations, '邮件发送成功', 'Send email successfully'), defineProperty_default()(_translations, '邮件发送失败，请稍后重试', 'Failed to send email, please try again'), defineProperty_default()(_translations, '自动计算', 'auto-calculation'), defineProperty_default()(_translations, '发票申请', 'Apply Invoice'), defineProperty_default()(_translations, '发票查询', 'Query invoices'), defineProperty_default()(_translations, '请填写小票号', 'Please fill in ticket'), defineProperty_default()(_translations, '请填写订单金额', 'Please fill in amount'), defineProperty_default()(_translations, 'PDF下载链接已复制到粘贴板', 'Copy pdf url successfully'), defineProperty_default()(_translations, 'PDF下载链接复制到粘贴板失败，请选择邮件发送', 'Fail to copy pdf url'), defineProperty_default()(_translations, '个人', 'Person'), defineProperty_default()(_translations, '非企业性单位', 'Non-bussiness'), _translations);

/* harmony default export */ var en = (translations);
// CONCATENATED MODULE: ./src/common/i18n/zh-CN.js


var zh_CN__translations;

/**
 * 简体中文语言包
 *
 *
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

var zh_CN_translations = (zh_CN__translations = {
  //操作
  '提交': '提交',
  '下一步': '下一步',
  '返回': '返回',
  '关闭': '关闭',
  '保存': '保存',
  '保存并验真': '保存并验真',
  '确定': '确定',
  '上传': '上传',
  '取消': '取消',
  '编辑': '编辑',
  '编辑及验真': '编辑及验真',
  '报销': '报销',
  '打印': '打印',
  '删除': '删除',

  '登录': '登录',
  '获取验证码': '获取验证码',
  '获取': '获取',
  '绑定': '绑定',

  '选择发票抬头': '选择发票抬头',
  '使用微信抬头': '使用微信抬头',

  '查看发票': '查看发票',
  '查看票据': '查看票据',
  '下载发票': '下载发票',
  '发到邮箱': '发到邮箱',
  '复制发票链接': '复制发票链接',
  '放入卡包': '放入卡包',
  '添加抬头': '添加抬头',
  '添加标签': '添加标签',
  '更多信息': '更多信息',
  '更多操作': '更多操作',
  '推荐给朋友': '推荐给朋友',
  '设置标签': '设置标签',
  '清理缓存': '清理缓存',

  //提示
  '标签管理小提示': '小提示:左滑列表可以编辑标签哦',
  '提示': '提示',
  '删除警告': '删除后无法恢复,确定要继续?',
  '长按下面文字复制': '长按下面文字复制链接',
  '加载完毕': '加载完毕',
  '加载中': '加载中',
  '加载失败': '加载失败',
  '没有任何记录': '没有任何记录',
  '本服务由华润万家提供': '本服务由华润万家提供',
  '必填': '必填',
  '选填': '选填',
  '操作成功': '操作成功',
  '删除成功': '删除成功',
  '修改成功': '修改成功',
  '长按识别二维码关注公众号并开票': '长按识别二维码关注公众号并开票',
  '开票成功提示': '亲爱的用户，您的开票申请已经提交成功，请近期留意开票结果。',
  '抬头上传成功提示': '抬头已上传成功，请耐心等待开票',

  '开票注意事项': '注：根据国家税务总局2017年第16号第二条规定，发票内容应该按照实际销售情况如实开具(仅提供明细开具).',
  '税号有误': '税号有误',
  '发票抬头长度小于100': '发票抬头长度小于100',

  '抬头信息': '抬头信息',
  '订单信息': '订单信息',
  '请准确填写抬头信息': '请准确填写抬头信息',
  '请准确填写收件人信息': '请准确填写收件人信息',
  '获取订单信息失败': '获取订单信息失败',
  '表单验证失败提示': '信息填写不完整或格式错误',
  '编辑增值税发票友情提示': '注：增值税发票、机动车销售统一发票只需编辑上面几项，其他信息在保存验真成功后会自动更新',

  '发票验真结果法律说明': '发票验真结果不作为法律依据，请以当地税务机关鉴定为准。',
  '该发票已通过国税局验真': '该发票已通过国税局验真.',
  '该发票未验真': '该发票未验真',
  '该发票验真中': '该发票正在进行验真,请稍后查看验真结果',
  '保存成功': '保存成功',
  '保存失败': '保存失败',
  '提交成功': '提交成功',
  '编辑增值税发票保存成功': '票据信息保存成功，验真后自动更新其他信息，这可能需要几分钟的时间',
  '票据信息保存成功': '票据信息保存成功',

  '请输入手机号码': '请输入手机号码',
  '请输入收票邮箱': '请输入收票邮箱',
  '请输入邮箱': '请输入邮箱',
  '请输入抬头(必填)': '请输入抬头(必填)',
  '请输入手机号码(必填)': '请输入手机号码(必填)',
  '请输入收票邮箱(必填)': '请输入收票邮箱(必填)',

  '请选择发票抬头': '请选择发票抬头',
  '请选择抬头': '请选择抬头',
  '请输入抬头': '请输入抬头',

  '请输入购销方名称': '请输入购销方名称',
  '请输入验证码': '请输入验证码',

  '请输入标签名': '请输入标签名',
  '标签名已存在': '标签名已经存在',
  '标签名称过长': '标签名长度小于8',

  '10或12位': '10或12位数字或大写字母',
  '8位': '8位',
  '不含税': '不含税',
  '输入后6位': '输入后6位',

  '请选择票据分类': '请选择票据分类',
  '请输入车次': '请输入车次',
  '请输入航班': '请输入飞机航班号',
  '请选择始发地': '请选择始发地',
  '请选择到达地': '请选择到达地',
  '请选择出行日期': '请选择出行日期',
  '票据说明': '票据说明',
  '绑定手机邮箱提示': '为了您的发票安全，请绑定手机和收票邮箱',

  '请选择发票日期': '请选择发票日期',
  '票据影像不存在': '票据影像不存在',
  '已经被处理的票据不允许删除': '已经被处理的票据不允许删除',
  '验真成功或验真中的票据不允许编辑': '验真成功或验真中的票据不允许编辑',

  '手机号绑定成功': '手机号绑定成功',
  '手机号解除绑定成功': '手机号解除绑定成功',
  '验证码已发送,请注意查收': '验证码已发送,请注意查收',

  '手机号码未绑定': '手机号码未绑定',
  '收票邮箱未设置': '收票邮箱未设置',
  '请设置': '请设置',
  '未设置': '未设置',
  '解除绑定警告': '解绑后,您的票据安全将失去保障,确定要继续?',
  '文件提交成功': '文件提交成功',
  '增值税发票上传成功': '发票已放入我的票夹中，等待识别和验真.',
  '微信发票导入成功': '微信发票导入成功',
  '下拉刷新': '下拉刷新',
  '增值税发票拍照说明': '增值税专用发票、增值税普通发票、增值税电子普通发票、增值税电子普通发票(通行费)、增值税普通发票(卷票)等;',
  '其他票据拍照说明': '火车票、出租车票、飞机票、通讯费发票、银行收款凭证、定额发票、境外发票等；',
  '扫发票二维码': '扫发票二维码',
  '扫发票二维码说明': '扫描二维码功能不支持电子票；',
  '正在进行图片预处理': '正在进行图片预处理',
  '正在上传文件': '正在上传文件',
  '发票影像列表是空的，无法上传': '发票影像列表是空的，无法上传',
  '共上传': '共上传',
  '个发票影像': '个发票影像',
  '无': '无',
  '请输入名称': '请输入名称',
  '该终端不支持扫一扫功能': '该终端不支持扫一扫功能',
  '已被他人保存': '此发票已被他人占用，无法报销',

  //页面名称  栏目标题
  // '增值税专用发票':'增值税专用发票',
  // '增值税普通发票':'增值税普通发票',
  // '增值税普通发票(农产品)':'增值税普通发票(农产品)',
  // '增值税电子普通发票':'增值税电子普通发票',
  // '增值税普通发票(卷票)':'增值税普通发票(卷票)',
  // '普通发票':'普通发票',
  // '机动车销售统一发票':'机动车销售统一发票',
  // '飞机票':'飞机票',
  // '火车票':'火车票',
  // '出租车票':'出租车票',
  // '通讯发票':'通讯发票',

  '票税助手': '票税助手',
  '订单发票': '订单发票',
  '发票影像': '发票影像',
  '拍发票': '拍发票',
  '票据详情': '票据详情',
  '标签管理': '标签管理',

  '导入微信发票': '导入发票',
  '共': '共',
  '张票据，累计金额': '张票据，累计金额',
  '即将开通，敬请期待': '即将开通，敬请期待',
  '选取发票失败': '选取发票失败',
  '取消选取发票': '取消选取发票',

  '抬头管理': '抬头管理',
  '开户行': '开户行',
  '发票号码': '发票号码',
  '发票代码': '发票代码',
  '您要添加哪种票据': '您要添加哪种票据?',
  '拍照技巧': '拍照技巧',
  '上传发票PDF': '上传发票PDF',
  '上传发票': '上传发票',
  '确定上传发票': '确定上传发票'
}, defineProperty_default()(zh_CN__translations, '\u626B\u53D1\u7968\u4E8C\u7EF4\u7801', '扫发票二维码'), defineProperty_default()(zh_CN__translations, '帮助中心', '帮助中心'), defineProperty_default()(zh_CN__translations, '个人中心', '个人中心'), defineProperty_default()(zh_CN__translations, '关于我们', '关于我们'), defineProperty_default()(zh_CN__translations, '绑定手机', '绑定手机'), defineProperty_default()(zh_CN__translations, '绑定邮箱', '绑定邮箱'), defineProperty_default()(zh_CN__translations, '设置收票邮箱', '设置收票邮箱'), defineProperty_default()(zh_CN__translations, '重新绑定手机', '重新绑定手机'), defineProperty_default()(zh_CN__translations, '解除绑定', '解除绑定'), defineProperty_default()(zh_CN__translations, '登录票税助手', '登录票税助手'), defineProperty_default()(zh_CN__translations, '验证码', '验证码'), defineProperty_default()(zh_CN__translations, "订单号", "订单号"), defineProperty_default()(zh_CN__translations, '订单金额', '订单金额'), defineProperty_default()(zh_CN__translations, '订单日期', '订单日期'), defineProperty_default()(zh_CN__translations, '发票日期', '发票日期'), defineProperty_default()(zh_CN__translations, '发票金额', '发票金额'), defineProperty_default()(zh_CN__translations, '发票详情', '发票详情'), defineProperty_default()(zh_CN__translations, '编辑发票', '编辑发票'), defineProperty_default()(zh_CN__translations, '不含税金额', '不含税金额'), defineProperty_default()(zh_CN__translations, '税额', '税额'), defineProperty_default()(zh_CN__translations, '含税金额', '含税金额'), defineProperty_default()(zh_CN__translations, '新增抬头', '新增抬头'), defineProperty_default()(zh_CN__translations, '新增标签', '新增标签'), defineProperty_default()(zh_CN__translations, '新增票据', '新增票据'), defineProperty_default()(zh_CN__translations, '编辑票据', '编辑票据'), defineProperty_default()(zh_CN__translations, '新增发票', '新增发票'), defineProperty_default()(zh_CN__translations, '上传抬头', '上传抬头'), defineProperty_default()(zh_CN__translations, '增值税发票', '增值税发票'), defineProperty_default()(zh_CN__translations, '其他票据', '其他票据'), defineProperty_default()(zh_CN__translations, '抬头类型', '抬头类型'), defineProperty_default()(zh_CN__translations, '企业', '企业'), defineProperty_default()(zh_CN__translations, '个人或政府机构', '个人/政府机构'), defineProperty_default()(zh_CN__translations, '发票类型', '发票类型'), defineProperty_default()(zh_CN__translations, '电子发票', '电子发票'), defineProperty_default()(zh_CN__translations, '纸质发票', '纸质发票'), defineProperty_default()(zh_CN__translations, '抬头', '抬头'), defineProperty_default()(zh_CN__translations, '发票抬头', '发票抬头'), defineProperty_default()(zh_CN__translations, '税号', '税号'), defineProperty_default()(zh_CN__translations, '手机号码', '手机号码'), defineProperty_default()(zh_CN__translations, '手机号', '手机号'), defineProperty_default()(zh_CN__translations, '邮箱', '邮箱'), defineProperty_default()(zh_CN__translations, '收票邮箱', '收票邮箱'), defineProperty_default()(zh_CN__translations, '地址', '地址'), defineProperty_default()(zh_CN__translations, '电话', '电话'), defineProperty_default()(zh_CN__translations, '电话号码', '电话号码'), defineProperty_default()(zh_CN__translations, '企业地址', '企业地址'), defineProperty_default()(zh_CN__translations, '开户银行', '开户银行'), defineProperty_default()(zh_CN__translations, '银行账号', '银行账号'), defineProperty_default()(zh_CN__translations, '费用', '费用'), defineProperty_default()(zh_CN__translations, '元', '元'), defineProperty_default()(zh_CN__translations, '开具发票', '开具发票'), defineProperty_default()(zh_CN__translations, '二维码开票', '二维码开票'), defineProperty_default()(zh_CN__translations, '关注公众号', '关注公众号'), defineProperty_default()(zh_CN__translations, '增值税电子普通发票', '增值税电子普通发票'), defineProperty_default()(zh_CN__translations, '销售方', '销售方'), defineProperty_default()(zh_CN__translations, '购买方', '购买方'), defineProperty_default()(zh_CN__translations, '\u65B0\u589E\u62AC\u5934', '新增抬头'), defineProperty_default()(zh_CN__translations, '编辑抬头', '编辑抬头'), defineProperty_default()(zh_CN__translations, '抬头详情', '抬头详情'), defineProperty_default()(zh_CN__translations, '默认抬头', '默认抬头'), defineProperty_default()(zh_CN__translations, '默认', '默认'), defineProperty_default()(zh_CN__translations, '设为默认', '设为默认'), defineProperty_default()(zh_CN__translations, '报销发票', '报销发票'), defineProperty_default()(zh_CN__translations, '已开发票', '已开发票'), defineProperty_default()(zh_CN__translations, '我的票夹', '我的票夹'), defineProperty_default()(zh_CN__translations, '票夹', '票夹'), defineProperty_default()(zh_CN__translations, '发票验真', '发票验真'), defineProperty_default()(zh_CN__translations, '发票归集', '发票归集'), defineProperty_default()(zh_CN__translations, '分类', '分类'), defineProperty_default()(zh_CN__translations, '类型', '类型'), defineProperty_default()(zh_CN__translations, '状态', '状态'), defineProperty_default()(zh_CN__translations, '日期', '日期'), defineProperty_default()(zh_CN__translations, '归集日期', '归集日期'), defineProperty_default()(zh_CN__translations, '校验码', '校验码'), defineProperty_default()(zh_CN__translations, '查看验真结果', '查看验真结果'), defineProperty_default()(zh_CN__translations, '标签', '标签'), defineProperty_default()(zh_CN__translations, '管理标签', '管理标签'), defineProperty_default()(zh_CN__translations, '商品明细', '商品明细'), defineProperty_default()(zh_CN__translations, '名称', '名称'), defineProperty_default()(zh_CN__translations, '金额', '金额'), defineProperty_default()(zh_CN__translations, '税率', '税率'), defineProperty_default()(zh_CN__translations, '金额/税率', '金额/税率'), defineProperty_default()(zh_CN__translations, '上拉加载更多', '上拉加载更多'), defineProperty_default()(zh_CN__translations, '\u4E0B\u62C9\u5237\u65B0', '下拉刷新'), defineProperty_default()(zh_CN__translations, '松开加载', '松开加载'), defineProperty_default()(zh_CN__translations, '松开刷新', '松开刷新'), defineProperty_default()(zh_CN__translations, '备注', '备注'), defineProperty_default()(zh_CN__translations, '发票备注', '发票备注'), defineProperty_default()(zh_CN__translations, '个人备注', '个人备注'), defineProperty_default()(zh_CN__translations, '始发地', '始发地'), defineProperty_default()(zh_CN__translations, '到达地', '到达地'), defineProperty_default()(zh_CN__translations, '从', '从'), defineProperty_default()(zh_CN__translations, '到', '到'), defineProperty_default()(zh_CN__translations, '上车时间', '上车时间'), defineProperty_default()(zh_CN__translations, '下车时间', '下车时间'), defineProperty_default()(zh_CN__translations, '出行日期', '出行日期'), defineProperty_default()(zh_CN__translations, '车次', '车次'), defineProperty_default()(zh_CN__translations, '航班', '航班'), defineProperty_default()(zh_CN__translations, '票据信息', '票据信息'), defineProperty_default()(zh_CN__translations, '服务电话', '服务电话'), defineProperty_default()(zh_CN__translations, '服务邮箱', '服务邮箱'), defineProperty_default()(zh_CN__translations, '已报销', '已报销'), defineProperty_default()(zh_CN__translations, '报销中', '报销中'), defineProperty_default()(zh_CN__translations, '未报销', '未报销'), defineProperty_default()(zh_CN__translations, '待识别', '待识别'), defineProperty_default()(zh_CN__translations, '识别中', '识别中'), defineProperty_default()(zh_CN__translations, '识别完成', '识别完成'), defineProperty_default()(zh_CN__translations, '识别失败', '识别失败'), defineProperty_default()(zh_CN__translations, '验真成功', '验真成功'), defineProperty_default()(zh_CN__translations, '验真失败', '验真失败'), defineProperty_default()(zh_CN__translations, '待验真', '待验真'), defineProperty_default()(zh_CN__translations, '验真中', '验真中'), defineProperty_default()(zh_CN__translations, '纸质发票邮寄地址', '纸质发票邮寄地址'), defineProperty_default()(zh_CN__translations, '收件人', '收件人'), defineProperty_default()(zh_CN__translations, '联系电话', '联系电话'), defineProperty_default()(zh_CN__translations, '所在地区', '所在地区'), defineProperty_default()(zh_CN__translations, '详细地址', '详细地址'), defineProperty_default()(zh_CN__translations, '电话有误', '电话有误'), defineProperty_default()(zh_CN__translations, '请使用微信或支付宝开票', '请使用微信或支付宝开票'), defineProperty_default()(zh_CN__translations, '订单异常，无法开票，请联系开票员', '订单异常，无法开票，请联系开票员'), defineProperty_default()(zh_CN__translations, '门店号', '门店号'), defineProperty_default()(zh_CN__translations, '纸质专票', '纸质专票'), defineProperty_default()(zh_CN__translations, '小票已申请开票，请勿重复申请', '小票已申请开票，请勿重复申请'), defineProperty_default()(zh_CN__translations, '房间号', '房间号'), defineProperty_default()(zh_CN__translations, '姓名', '姓名'), defineProperty_default()(zh_CN__translations, '更新日期', '更新日期'), defineProperty_default()(zh_CN__translations, '工作流号', '工作流号'), defineProperty_default()(zh_CN__translations, '报销金额', '报销金额'), defineProperty_default()(zh_CN__translations, '发票开具成功', '发票开具成功'), defineProperty_default()(zh_CN__translations, '该发票已被他人领取', '发票已开具'), defineProperty_default()(zh_CN__translations, '发票开具中', '发票开具中'), defineProperty_default()(zh_CN__translations, '发票申请成功提示', '电子发票将于24小时内完成开具。开具成功后，您将收到消息通知'), defineProperty_default()(zh_CN__translations, '已被他人开具提示', '此票据已成功开具过发票，不可重复开票'), defineProperty_default()(zh_CN__translations, '开票申请提交成功', '开票申请提交成功'), defineProperty_default()(zh_CN__translations, '查看开票状态', '查看开票状态'), defineProperty_default()(zh_CN__translations, '所属集团', '所属集团'), defineProperty_default()(zh_CN__translations, '集团信息', '集团信息'), defineProperty_default()(zh_CN__translations, '集团名称', '集团名称'), defineProperty_default()(zh_CN__translations, '请输入您所在集团的全称', '请输入您所在集团的全称'), defineProperty_default()(zh_CN__translations, '个人工号', '个人工号'), defineProperty_default()(zh_CN__translations, '请输入您的个人工号', '请输入您的个人工号'), defineProperty_default()(zh_CN__translations, '以上信息仅作为公司系统接入时发票抽取凭证', '以上信息仅作为公司系统接入时发票抽取凭证'), defineProperty_default()(zh_CN__translations, '本功能仅限合作商户使用', '本功能仅限合作商户使用'), defineProperty_default()(zh_CN__translations, '集团绑定成功', '集团绑定成功'), defineProperty_default()(zh_CN__translations, '集团名称不能超过200位', '集团名称不能超过200位'), defineProperty_default()(zh_CN__translations, '个人工号不能超过20位', '个人工号不能超过20位'), defineProperty_default()(zh_CN__translations, '扫二维码添加的发票无照片！如须保存照片，请选择其他方式', '扫二维码添加的发票无照片！如须保存照片，请选择其他方式'), defineProperty_default()(zh_CN__translations, '已占用', '已占用'), defineProperty_default()(zh_CN__translations, '填写2项数据，可完成绑定；清空2项数据，可完成解绑', '填写2项数据，可完成绑定；清空2项数据，可完成解绑'), defineProperty_default()(zh_CN__translations, '已完成', '已完成'), defineProperty_default()(zh_CN__translations, '开票中', '开票中'), defineProperty_default()(zh_CN__translations, '月份', '月份'), defineProperty_default()(zh_CN__translations, '开票状态', '开票状态'), defineProperty_default()(zh_CN__translations, '请填写正确的邮箱', '请填写正确的邮箱'), defineProperty_default()(zh_CN__translations, '邮件发送成功', '邮件发送成功'), defineProperty_default()(zh_CN__translations, '邮件发送失败，请稍后重试', '邮件发送失败，请稍后重试'), defineProperty_default()(zh_CN__translations, '自动计算', '自动计算'), defineProperty_default()(zh_CN__translations, '发票申请', '发票申请'), defineProperty_default()(zh_CN__translations, '发票查询', '发票查询'), defineProperty_default()(zh_CN__translations, '请填写小票号', '请填写小票号'), defineProperty_default()(zh_CN__translations, '请填写订单金额', '请填写订单金额'), defineProperty_default()(zh_CN__translations, 'PDF下载链接已复制到粘贴板', 'PDF下载链接已复制到粘贴板'), defineProperty_default()(zh_CN__translations, 'PDF下载链接复制到粘贴板失败，请选择邮件发送', 'PDF下载链接复制到粘贴板失败，请选择邮件发送'), defineProperty_default()(zh_CN__translations, '个人', '个人'), defineProperty_default()(zh_CN__translations, '非企业性单位', '非企业性单位'), defineProperty_default()(zh_CN__translations, '金额提示', '1、代收银租赁商品、服务类收入（如：代收代征款项、话费充值、鲜花、包装、彩票等）、指定在租户商品中使用的券不开票；</br>' + '2、预付卡（包括万家及第三方的预付卡，含深圳通等公交卡）消费、全场优惠通用券（品类优惠券视同全场优惠通用券）需按商品销售额比例在各商品中进行分摊计算，有尾差的计入最后一个商品；</br>' + '3、第三方支付的折扣/优惠金额不开票（如：微信折扣金额、银行等金融机构参与满减的金额不开票-满200减8,88这部分不开票）；</br>' + '4、积分换购消费金额不开票；</br>' + '5、可开票金额小于或者等于0的不开票（如：全部用预付卡支付购买电器的，按0.01元开票），但是电器等需要凭发票保修的商品，按0.01元开票。'), defineProperty_default()(zh_CN__translations, '金额提示1', '1、代收银租赁商品、服务类收入（如：代收代征款项、话费充值、鲜花、包装、彩票等）、指定在租户商品中使用的券不开票；'), defineProperty_default()(zh_CN__translations, '金额提示2', '2、预付卡（包括万家及第三方的预付卡，含深圳通等公交卡）消费、全场优惠通用券（品类优惠券视同全场优惠通用券）需按商品销售额比例在各商品中进行分摊计算，有尾差的计入最后一个商品；'), defineProperty_default()(zh_CN__translations, '金额提示3', '3、第三方支付的折扣/优惠金额不开票（如：微信折扣金额、银行等金融机构参与满减的金额不开票-满200减8,88这部分不开票）；'), defineProperty_default()(zh_CN__translations, '金额提示4', '4、积分换购消费金额不开票；'), defineProperty_default()(zh_CN__translations, '金额提示5', '5、可开票金额小于或者等于0的不开票（如：全部用预付卡支付购买电器的，按0.01元开票），但是电器等需要凭发票保修的商品，按0.01元开票。'), zh_CN__translations);
/* harmony default export */ var zh_CN = (zh_CN_translations);
// CONCATENATED MODULE: ./src/store/index.js













// 开发模式下使用日志，和谷歌浏览器里面的vuedevtool插件类似
// 子修改state的时候会在控制台打印一些信息



vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

// 调试,开发模式开启严格模式，要使用mutations提交
var debug = "production" !== 'production';

var store = new vuex_esm["a" /* default */].Store({
  modules: {
    i18n: vuex_i18n_es["a" /* default */].store,
    common: modules_common,
    invoice: invoice
  },

  actions: actions,
  getters: getters,
  state: state_default.a,
  mutations: mutations_default.a,
  strict: debug,
  plugins: debug ? [logger_default()()] : []
});

vue_esm["a" /* default */].use(vuex_i18n_es["a" /* default */].plugin, store);




// 将语言包加入项目   多语言设置
vue_esm["a" /* default */].i18n.add('en', en);
vue_esm["a" /* default */].i18n.add('zh-CN', zh_CN);
// 设置语言包  TODO...根据客户端语言环境，自动变更语言包
vue_esm["a" /* default */].i18n.set(Object(common["e" /* getBrowserLanguage */])());

// Vue.i18n.set('en');

// alert(getBrowserLanguage())

/* harmony default export */ var src_store = (store);

//多语言设置
// var vuxLocales = require('json!yaml!vux/src/locales/all.yml')
// var componentsLocales = require('json!yaml!src/locales/components.yml')
// var globalLocales = require('json!yaml!src/locales/global_locales.yml') || {en: {}, 'zh-CN': {}}

// var finalLocales = {
//   'en': objectAssign(vuxLocales['en'], componentsLocales['en'], globalLocales['en']),
//   'zh-CN': objectAssign(vuxLocales['zh-CN'], componentsLocales['zh-CN'], globalLocales['zh-CN'])
// }

// for (let i in finalLocales) {
//   Vue.i18n.add(i, finalLocales[i])
// }
// Vue.i18n.set('zh-CN')
// EXTERNAL MODULE: ./src/common/js/const.js
var js_const = __webpack_require__("2QZS");

// CONCATENATED MODULE: ./src/router/index.js






// 首页
var login = function login(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__("XP/F"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var router_state = function state(r) {
  return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(5)]).then((function () {
    return r(__webpack_require__("O4Fc"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 二维码开票
var OrderInvoiceIssue = function OrderInvoiceIssue(r) {
  return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
    return r(__webpack_require__("QtLH"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 发票列表
var OrderInvoices = function OrderInvoices(r) {
  return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(1)]).then((function () {
    return r(__webpack_require__("O+rg"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 发票详情页
var OrderInvoicesOwtDetail = function OrderInvoicesOwtDetail(r) {
  return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
    return r(__webpack_require__("pWCb"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 发票影像页
var OrderInvoicesImage = function OrderInvoicesImage(r) {
  return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(7)]).then((function () {
    return r(__webpack_require__("73aI"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 发票抬头  增删改查,上传抬头
var InvoiceTitleIndex = function InvoiceTitleIndex(r) {
  return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
    return r(__webpack_require__("GmWX"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var InvoiceTitleCreate = function InvoiceTitleCreate(r) {
  return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(6)]).then((function () {
    return r(__webpack_require__("IAv4"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var InvoiceTitleDetail = function InvoiceTitleDetail(r) {
  return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(8)]).then((function () {
    return r(__webpack_require__("CPdw"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: '/',
  redirect: '/index/login'
}, {
  path: '/index/login',
  name: js_const["c" /* routerNames */].login,
  meta: {
    title: '登录',
    scrollToTop: true,
    keepAlive: true,
    transition: false
  },
  component: login
}, {
  path: '/orderInvoice/issue',
  name: js_const["c" /* routerNames */].OrderInvoiceIssue,
  meta: {
    title: '开具发票',
    scrollToTop: true,
    keepAlive: true,
    transition: false
  },
  component: OrderInvoiceIssue
}, {
  path: '/orderInvoice/invoices',
  name: js_const["c" /* routerNames */].OrderInvoices,
  meta: {
    title: '发票列表',
    scrollToTop: true,
    keepAlive: true,
    transition: false
  },
  component: OrderInvoices
}, {
  path: '/orderInvoice/owtDetail/:id',
  name: js_const["c" /* routerNames */].OrderInvoicesOwtDetail,
  meta: {
    title: '发票详情',
    scrollToTop: true,
    keepAlive: true,
    transition: false
  },
  component: OrderInvoicesOwtDetail
}, {
  path: '/orderInvoice/invoiceImage',
  name: js_const["c" /* routerNames */].OrderInvoicesImage,
  meta: {
    title: '发票内容',
    scrollToTop: true,
    keepAlive: true,
    transition: false
  },
  component: OrderInvoicesImage
}, {
  path: '/invoiceTitle',
  redirect: '/invoiceTitle/index'
}, {
  path: '/invoiceTitle/index',
  name: js_const["c" /* routerNames */].InvoiceTitleIndex,
  meta: {
    title: '发票抬头',
    scrollToTop: true,
    keepAlive: true,
    transition: false
  },
  component: InvoiceTitleIndex
}, {
  path: '/invoiceTitle/create',
  name: js_const["c" /* routerNames */].InvoiceTitleCreate,
  meta: {
    title: '新增抬头',
    scrollToTop: true,
    keepAlive: true,
    transition: false
  },
  component: InvoiceTitleCreate
}, {
  path: '/invoiceTitle/detail/:id',
  name: js_const["c" /* routerNames */].InvoiceTitleDetail,
  meta: {
    title: '抬头详情',
    scrollToTop: true,
    keepAlive: true,
    transition: false
  },
  component: InvoiceTitleDetail
}, {
  path: '/orderInvoice/state',
  name: js_const["c" /* routerNames */].state,
  meta: {
    title: '查看状态',
    scrollToTop: true,
    keepAlive: true,
    transition: false
  },
  component: router_state
}];

var router = new vue_router_esm["a" /* default */]({
  //mode: 'history',
  //base:'/sg/',
  routes: routes
});

var router_commit = src_store.commit || src_store.dispatch;
// 处理 路由切换效果
var router_history = window.sessionStorage;
router_history.clear();
var historyCount = router_history.getItem('count') * 1 || 0;
router_history.setItem('/', 0);
// var $self = this;

router.beforeEach(function (to, from, next) {
  var toIndex = router_history.getItem(to.name);
  var fromIndex = router_history.getItem(from.name);
  // 处理 路由切换效果
  if (from.name != null) {
    if (toIndex) {
      if (toIndex > fromIndex) {
        router_commit(UPDATE_DIRECTION, 'forward');
      } else {
        router_commit(UPDATE_DIRECTION, 'reverse');
      }
    } else {
      ++historyCount;
      router_history.setItem('count', historyCount);
      to.name !== '/' && router_history.setItem(to.name, historyCount);
      router_commit(UPDATE_DIRECTION, 'forward');
    }
  } else {
    if (toIndex) {
      if (toIndex > fromIndex) {
        router_commit(UPDATE_DIRECTION, 'forward');
      } else {
        router_commit(UPDATE_DIRECTION, 'reverse');
      }
    } else {
      ++historyCount;
      router_history.setItem('count', historyCount);
      to.name !== '/' && router_history.setItem(to.name, historyCount);
      router_commit(UPDATE_DIRECTION, 'forward');
    }
  }
  // 国际化 放在APP.vue中处理
  // document.title = to.meta.title
  router_commit(UPDATE_TITLE, to.meta.title);
  // loading
  // commit(types.UPDATE_LOADING, true)
  setTimeout(function () {
    router_commit(UPDATE_LOADING, true);
  }, 200);
  next();
});

router.afterEach(function (to) {
  setTimeout(function () {
    router_commit(UPDATE_LOADING, false);
  }, 500);

  try {
    // console.log('当前请求路由名称：', to.name)
    if (to.name === js_const["c" /* routerNames */].OrderInvoiceDetail || to.name === js_const["c" /* routerNames */].InvoiceDetail) {
      // location.replace(to.fullPath);
      // document.body.style['background-color'] = '#2b88d8';
      // document.getElementById('vux_view_box_body')
      // $('body').css({'background-color':'#2b88d8'});
    } else {
        // document.body.style['background-color'] = '#fbf9fe';
        // $('body').css({'background-color':'#fbf9fe'});
      }
  } catch (error) {}
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
var promise = __webpack_require__("rVsN");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/_qs@6.5.2@qs/lib/index.js
var _qs_6_5_2_qs_lib = __webpack_require__("6iV/");
var _qs_6_5_2_qs_lib_default = /*#__PURE__*/__webpack_require__.n(_qs_6_5_2_qs_lib);

// EXTERNAL MODULE: ./src/config/base.js
var base = __webpack_require__("Q4A5");

// CONCATENATED MODULE: ./src/common/js/http.js

/**
 * ajax程序改造
 * 在main.js中引用，
 *
 *
import http from './common/js/http'
Vue.use(http)
 *
 * 在视图组件中使用
 *
 this.$http
    .post(
        'https://www.easy-mock.com/mock/5a4896ba62de717d44f2406e/api/v1/login',
        data
    )
    .then(res => {
        if (res.data.data.code === 0) {
        }
    })
 *
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */




/**
 * http配置
 */
var http_instance = _axios_0_17_1_axios_default.a.create({
    baseURL: base["a" /* default */].api.api_root,
    timeout: 10000,
    withCredentials: true, // 是否允许带cookie这些
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': "application/x-www-form-urlencoded; charset=utf-8;"
    }
});

// http request 拦截器
http_instance.interceptors.request.use(function (config) {
    // POST传参序列化
    if (config.method === 'post') {
        config.data = _qs_6_5_2_qs_lib_default.a.stringify(config.data);
    }
    // 若是有做鉴权token , 就给头部带上token
    if (localStorage.token) {
        config.headers.Authorization = localStorage.token;
    }
    return config;
}, function (error) {
    return promise_default.a.reject(error);
});

// http response 拦截器
http_instance.interceptors.response.use(function (response) {
    // token 过期或者其他情况的判断
    // if (response.data.code === -1) {
    //   localStorage.removeItem('token')
    //   router.replace({
    //     path: 'login',
    //     query: { redirect: router.currentRoute.fullPath }
    //   })
    // }else{
    //   return response
    // }

    // 返回响应时做一些处理，我们这里直接返回
    return response;
}, function (error) {
    // if (error.response) {
    //   switch (error.response.status) {
    //     case 401:
    //       // 返回 401 清除token信息并跳转到登录页面
    //       localStorage.removeItem('token')
    //       router.replace({
    //         path: 'login',
    //         query: { redirect: router.currentRoute.fullPath }
    //       })
    //   }
    // }
    // 当响应异常时做一些处理
    return promise_default.a.reject(error);
});

// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
/* harmony default export */ var http = ({
    install: function install(Vue, Option) {
        Object.defineProperty(Vue.prototype, '$http', { value: http_instance });
    }
});
// CONCATENATED MODULE: ./src/common/js/api.js


/**
 * API接口配置
 *
 */






/**
 * 获取自定义后的 ajax方法
 */
function getHttpIntegrate() {
  /**
   * http配置,调用集成接口
   */
  var instance = _axios_0_17_1_axios_default.a.create({
    baseURL: base["a" /* default */].api.api_owt,
    timeout: 60000,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8;"
      //"Content-Type": "application/json;charset=utf-8"
    }
  });
  var shaEncrypt = function shaEncrypt(params) {
    //要加密的字符字符串
    var encryptStr = 'token=' + params.token + '&appKey=' + params.appKey + '&timestamp=' + params.timestamp;
    encryptStr += '&v=' + params.v + '&resouce=' + params.resouce;
    //这里用的是require方法，所以没用import
    var sha256 = __webpack_require__("e9Q/").sha256;
    //console.log(encryptStr);
    return sha256(encryptStr);
  };
  var setHeaders = function setHeaders(config) {
    var _params = {
      token: Object(common["g" /* getToken */])(),
      appKey: "PYT_APPKEY",
      timestamp: new Date().getTime(),
      v: "1.0",
      resouce: Object(common["f" /* getResouce */])(),
      reqJson: stringify_default()(config.data),
      sign: ""
    };
    config.headers.common['sign'] = shaEncrypt(_params);
    config.headers.common['token'] = _params.token;
    config.headers.common['appKey'] = _params.appKey;
    config.headers.common['timestamp'] = _params.timestamp;
    config.headers.common['v'] = _params.v;
    config.headers.common['resouce'] = _params.resouce;
  };
  // http request 拦截器
  instance.interceptors.request.use(function (config) {
    //加密
    setHeaders(config);
    // POST传参序列化
    if (config.method === "post") {
      config.data = _qs_6_5_2_qs_lib_default.a.stringify(config.data);
    }
    return config;
  }, function (error) {
    //console.log("request error:" + error);
    return promise_default.a.reject(error);
  });

  // http response 拦截器
  instance.interceptors.response.use(function (response) {
    // 返回响应时做一些处理，我们这里直接返回
    return response;
  }, function (error) {
    // 当响应异常时做一些处理\
    console.log("response error:" + error);
    return promise_default.a.reject('网络异常 ,请稍后重试');
  });
  return instance;
}

var api = {
  /**
   * 获取二维码
   */
  getToken: function getToken(openid) {
    var __params = { "openid": openid };
    return getHttpIntegrate().post('/weixin/token', __params);
  },

  /**
   * 获取二维码
   */
  getJsapiSign: function getJsapiSign(url) {
    var __params = { 'url': url };
    return getHttpIntegrate().post('/weixin/jsapiticket', __params);
  },

  /**
   * pdf转图片
   */
  pdfToImg: function pdfToImg(pdfUrl) {
    var __params = { 'pdfUrl': pdfUrl };
    return getHttpIntegrate().post('/xforce/pdftoimg', __params);
  },

  /**
   * 获取抬头列表
   */
  getInvoiceTitleList: function getInvoiceTitleList(page) {
    var __params = { 'page': page, 'size': 12 };
    return getHttpIntegrate().post('/invoice/title/unionid', __params);
  },

  /**
   * 获取抬头明细
   */
  getInvoiceTitleDetails: function getInvoiceTitleDetails(params) {
    return getHttpIntegrate().post("/invoice/title/id", params);
  },

  /**
   * 新增抬头
   */
  insertInvoiceTitle: function insertInvoiceTitle(params) {
    return getHttpIntegrate().post('/invoice/title/add', params);
  },

  /**
   * 新增抬头
   */
  delInvoiceTitle: function delInvoiceTitle(id) {
    var __params = { 'id': id };
    return getHttpIntegrate().post('/invoice/title/del', __params);
  },

  /**
   * 修改抬头
   */
  updateInvoiceTitle: function updateInvoiceTitle(params) {
    return getHttpIntegrate().post('/invoice/title/update', params);
  },

  /**
   * 获取订单信息
   */
  getOrderInfo: function getOrderInfo(orderNo) {
    var __params = { "orderNo": orderNo };
    return getHttpIntegrate().post("/order/query/id", __params);
  },

  /**
   * 转换订单信息
   */
  decryptOrder: function decryptOrder(url) {
    var __params = { "url": url };
    return getHttpIntegrate().post("/order/decrypt", __params);
  },

  /**
   * 申请开票
   */
  applyEInvoice: function applyEInvoice(__params) {
    return getHttpIntegrate().post("/invoice/apply", __params);
  },

  /**
   * 获取发票详情
   */
  getInvoiceDetail: function getInvoiceDetail(__id, invoiceNo, invoiceCode) {
    var __params = { "id": __id, 'invoiceNo': invoiceNo, 'invoiceCode': invoiceCode };
    if (__id != null && __id != '') {
      return getHttpIntegrate().post("/invoice/query/id", __params);
    } else {
      return getHttpIntegrate().post("/invoice/query/invoiceno", __params);
    }
  },

  /**
   * 获取发票列表
   */
  getInvoiceList: function getInvoiceList(page, size) {
    var __params = { "page": page, "size": size };
    return getHttpIntegrate().post("/invoice/query/list", __params);
  },

  /**
   *邮件发送
   */
  sendInvoiceEmail: function sendInvoiceEmail(invoiceId, email) {
    var __params = { 'mainId': invoiceId, 'mail': email };
    return getHttpIntegrate().post('/invoice/send/mail', __params);
  }
};

// 对 api 重新封装成一个plugin ,方便 Vue.use(xxxx)
//调用的时候 用 this.$webapi.deleteInvoiceTitle(....)
/* harmony default export */ var js_api = ({
  install: function install(Vue, Option) {
    Object.defineProperty(Vue.prototype, '$webapi', {
      value: api
    });
  }
});
// EXTERNAL MODULE: ./src/common/js/filter.js
var filter = __webpack_require__("7Krh");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("mdno");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/plugins/loading/index.js
var plugins_loading = __webpack_require__("/T/E");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/plugins/toast/index.js
var toast = __webpack_require__("9f8V");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/tools/date/format.js
var format = __webpack_require__("Hpey");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/plugins/datetime/index.js
var datetime = __webpack_require__("FUrK");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("e58e");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/tools/querystring/index.js
var querystring = __webpack_require__("ZCMT");
var querystring_default = /*#__PURE__*/__webpack_require__.n(querystring);

// CONCATENATED MODULE: ./src/main.js

/**
* main，程序入口
*
*  * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
* @link
* @create 2018-03-15
*/
















keys_default()(filter["a" /* default */]).forEach(function (k) {
  return vue_esm["a" /* default */].filter(k, filter["a" /* default */][k]);
});









vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(plugins_loading["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);

vue_esm["a" /* default */].use(datetime["a" /* default */]);
vue_esm["a" /* default */].use(plugins_confirm["a" /* default */]);

vue_esm["a" /* default */].config.productionTip = base["a" /* default */].debug;
vue_esm["a" /* default */].config.debug = base["a" /* default */].debug;
vue_esm["a" /* default */].config.devtools = base["a" /* default */].debug;
vue_esm["a" /* default */].config.warnExpressionErrors = base["a" /* default */].debug;
vue_esm["a" /* default */].prototype.$ajax = _axios_0_17_1_axios_default.a;

/**
* 那么之后任何组件中都可以通过 this.$wechat 访问到 wx 对象。
考虑到你需要在引入插件后调用wx.config方法进行配置，你可以通过 Vue.wechat 在组件外部访问wx对象。
jssdk需要请求签名配置，你可以直接使用下面的ajaxPlugin。
*/

vue_esm["a" /* default */].use(http);

vue_esm["a" /* default */].use(js_api);

var FastClick = __webpack_require__("iDdd");
FastClick.attach(document.body);

regGlobalMethod();

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  store: src_store,
  router: src_router,
  template: '<App/>',
  components: {
    App: src_App
  }
});

/**
* 注册全局的方法
*
* 在视图中 可以 用  this.$clog('xxxx')
*/
function regGlobalMethod() {

  vue_esm["a" /* default */].prototype.$routerNames = js_const["c" /* routerNames */];

  vue_esm["a" /* default */].prototype.$querystring = querystring_default.a;

  vue_esm["a" /* default */].prototype.$dateFormat = format["a" /* default */];

  vue_esm["a" /* default */].prototype.$clog = common["b" /* clog */];

  vue_esm["a" /* default */].prototype.$formatDateTime2 = common["c" /* formatDateTime2 */];

  vue_esm["a" /* default */].prototype.$formatDateTime3 = common["d" /* formatDateTime3 */];

  vue_esm["a" /* default */].prototype.$thousandBitSeparator = common["k" /* thousandBitSeparator */];

  vue_esm["a" /* default */].prototype.$cerr = function ($msg) {
    var str = Object(common["b" /* clog */])($msg, 'ERR');
    return str;
  };
}

/***/ }),

/***/ "Q4A5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 基础依赖配置
 *
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

/**当前运行环境 */
var envType = 1; //1开发服；2点检服；3演示服；4生产服务；5本地开发机;

var cfg = {
  envType: envType,
  //是否是调试模式
  debug: true,
  //是否要模拟登陆  需要服务APi支持，暂不启用
  autoLogin: false,
  //模拟登陆   账号
  autoLoginInfo: {
    source: '',
    openId: '',
    otId: ''
  },
  //api请求地址
  api: {
    /**开发者ID(AppID) */
    wechat_appId: '',
    /**只是登录时候调用的key */
    api_key: '',
    /**根api */
    api_root: '',
    /**新服务 根api */
    api_root2: '',
    /**http地址 api */
    api_root_http: '',
    /**集成服务 api */
    api_owt: ''
  }
};

//根据不同的环境输出不同的依赖配置
switch (envType) {
  //开发
  case 1:
    // cfg.debug = false;
    cfg.api.api_key = 'YoO45SINRHiOCISOfn3olA0bBvxCPsPf55CwX6FhAbTYM6nhFOa7jDqhMTu8LboKNLT3lD7i038%3D';
    //cfg.api.api_owt = 'http://localhost:8081/suguo'
    //cfg.api.api_owt = 'http://crvweixin.crv.com.cn/sg/einvoice'
    cfg.api.api_owt = 'https://ei.suguo.com.cn/einvoice';
    //cfg.api.api_owt = 'https://einvoiceuat.crv.com.cn/sg'
    break;
  default:
    // cfg.debug = true;
    cfg.api.api_key = 'YoO45SINRHiOCISOfn3olA0bBvxCPsPf55CwX6FhAbTYM6nhFOa7jDqhMTu8LboKNLT3lD7i038%3D';
    cfg.api.api_owt = 'hhttp://wuliu.crvweixin.crv.com.cn/h5';
    break;
}

/* harmony default export */ __webpack_exports__["a"] = (cfg);

/***/ }),

/***/ "S9nr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("ZLEe");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("hArn");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/components/datetime/datetimepicker.js + 3 modules
var datetimepicker = __webpack_require__("5KR3");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("CKVb");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("2vzc");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/mixins/uuid.js
var uuid = __webpack_require__("fqpJ");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/tools/date/format.js
var date_format = __webpack_require__("Hpey");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-01c14866","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var staticRenderFns = []
var esExports = { render: datetime_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_datetime = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/datetime/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("CbWb")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_datetime,
  src_components_datetime,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var _vux_2_9_2_vux_src_components_datetime = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SUeN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T4qG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports) {

/**
 * 定义公用的getters处理 ,
 * 全局getters
 * 例如正常组件里想 computed 一个状态但在vuex里面不知道怎么处理，就可以在这里处理

 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 *
 */

/***/ }),

/***/ "UmOo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z2Kc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_object-assign@4.1.1@object-assign/index.js
var _object_assign_4_1_1_object_assign = __webpack_require__("+Up5");
var _object_assign_4_1_1_object_assign_default = /*#__PURE__*/__webpack_require__.n(_object_assign_4_1_1_object_assign);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return _object_assign_4_1_1_object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return _object_assign_4_1_1_object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0972c17a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/x-header/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){_vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){_vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_header = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/x-header/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Iy0M")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_header,
  src_components_x_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var _vux_2_9_2_vux_src_components_x_header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cBXC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJNS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f4gh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("YKQd");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e03e7818","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("cBXC")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_2_vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hArn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-39bbf206","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("SUeN")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_2_vux_src_components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jHHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("uc2b");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7d481224","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("9ttw")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_2_vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lwq5":
/***/ (function(module, exports) {

/**
 * store state 核心
 *
  * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

//定义公用的getters处理 ,
//例如正常组件里想 computed 一个状态但在vuex里面不知道怎么处理，就可以在这里处理
//--import * as getters from './getters';
//定义我们vue组件要操作的动作事件, 比如请求一个异步操作,获取其他组件的状态等
//--import * as actions from './actions';
//操作和维护store的处理
//import mutations from './mutations';
//定义我们vue组件要操作的动作事件, 比如请求一个异步操作,获取其他组件的状态等

//全局state

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports) {

// import * as types from './mutation-types'
// 处理异步操作和封装多个mutation
////定义我们vue组件要操作的动作事件, 比如请求一个异步操作,获取其他组件的状态等
/**
 * 
 * 
    action去commit mutations
    action 和mutions 的定义方法是类似的，
    我们要dispatch 一个action, 所以actions 肯定有一个名字，
    dispatch action 之后它要做事情，就是commit mutation, 
    所以还要给它指定一个函数。因为要commit mutation ,
    所以 函数也会自动获得一个默认参数context,  
    它是一个store 实例，通过它可以获取到store 实例的属性和方法,
    如 context.state 就会获取到 state 属性， 
    context.commit 就会执行commit命令。

    教程：https://www.cnblogs.com/SamWeb/p/6543931.html
 * 
 * 
 * 全局actions
  * 目前此文件不使用，用actions/xx.js来分块管理
 */

/***/ }),

/***/ "mqrw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.9.2@vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("jHHs");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.2@vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6c86b0fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.2@vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _vux_2_9_2_vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.2@vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7KPW")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  _vux_2_9_2_vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules__vux_2_9_2_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r/Q/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tQvA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, exports) {

/**
 * 操作和维护store的处理
 * 
 * 在vue 中，只有mutation 才能改变state. 
   *  mutation 类似事件，每一个mutation都有一个类型和一个处理函数，
   * 因为只有mutation 才能改变state, 所以处理函数自动会获得一个默认参数 state.
   *  所谓的类型其实就是名字，action去comit 一个mutation, 
   * 它要指定去commit哪个mutation, 所以mutation至少需要一个名字，
   * commit mutation 之后， 要做什么事情，那就需要给它指定一个处理函数， 
   * 类型(名字) + 处理函数就构成了mutation. 现在store.js添加mutation.
 * 
 * 
    教程：https://www.cnblogs.com/SamWeb/p/6543931.html
    全局mutations
 * 目前此文件不使用，用modules/xx.js来分块管理
 * 
 * 
 * create by yangkun@xforceplus.com
 */

// import * as types from './mutation-types'
// // import {generateMixed} from './../common/js/common'
// // 同步方法
// const mutations = {
//     [types.UPDATE_USERINFO](state, { userInfo }) {
//         state.userInfo = userInfo
//     },
//     [types.UPDATE_TITLE](state, title) {
//         state.title = title
//     },
//     [types.UPDATE_LOADING](state, status) {
//         state.isLoading = status
//     },
//     [types.UPDATE_DIRECTION](state, direction) {
//         state.direction = direction
//     },
// }

// export default mutations

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.15e43b6707506d73e3ee.js